export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: any; output: any; }
  AWSPhone: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
  BigInt: { input: any; output: any; }
  Double: { input: any; output: any; }
}

export interface AccommodationForm {
  __typename?: 'AccommodationForm';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  episodeOfCareId?: Maybe<Scalars['ID']['output']>;
  formData: Scalars['AWSJSON']['output'];
  id: Scalars['ID']['output'];
  patientId: Scalars['ID']['output'];
  signedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  status: AccommodationFormStatus;
  submittedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
}

export interface AccommodationFormConnection {
  __typename?: 'AccommodationFormConnection';
  items: Array<AccommodationForm>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface AccommodationFormFilterInput {
  status?: InputMaybe<AccommodationFormStatus>;
}

export enum AccommodationFormStatus {
  Draft = 'DRAFT',
  Signed = 'SIGNED',
  Submitted = 'SUBMITTED'
}

export interface AccountOnBoardingEocInput {
  bodyRegion: Scalars['String']['input'];
  eocId: Scalars['ID']['input'];
}

export interface AddAdminInput {
  createdOn?: InputMaybe<Scalars['AWSDateTime']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
  permissions?: InputMaybe<AdminPermissionsInput>;
  userGroup: UserGroup;
}

export interface AddAppointmentInput {
  appointmentDate: Scalars['AWSDateTime']['input'];
  appointmentStatus: AppointmentStatus;
  appointmentType: AppointmentType;
  duration: Scalars['Int']['input'];
  episodeOfCareId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
  ptId: Scalars['ID']['input'];
  referralHistoryId?: InputMaybe<Scalars['String']['input']>;
}

export interface AddBillInput {
  amountPerCategory?: InputMaybe<Array<SingleCategoryPriceInput>>;
  appointmentId: Scalars['ID']['input'];
  claimId?: InputMaybe<Scalars['ID']['input']>;
  coinsurance: Scalars['String']['input'];
  deductible: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
  patientResponsibility: Scalars['String']['input'];
  totalAmount: Scalars['String']['input'];
}

export interface AddChatMessageInput {
  attachmentRefs?: InputMaybe<Array<InputMaybe<FileInput>>>;
  conversationId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  recipientId: Scalars['ID']['input'];
  senderCanvasStaffId?: InputMaybe<Scalars['ID']['input']>;
  senderDisplayName?: InputMaybe<Scalars['String']['input']>;
  senderId: Scalars['ID']['input'];
  senderUserGroup?: InputMaybe<UserGroup>;
  timestamp?: InputMaybe<Scalars['AWSDateTime']['input']>;
}

export interface AddClaimInput {
  appointmentId: Scalars['ID']['input'];
  benefitsAssignedToProvider?: InputMaybe<Scalars['Boolean']['input']>;
  billableStatus?: InputMaybe<Scalars['String']['input']>;
  billingProvider?: InputMaybe<ClaimProviderInput>;
  claimStatus?: InputMaybe<ClaimStatus>;
  dateOfService?: InputMaybe<Scalars['String']['input']>;
  diagnoses?: InputMaybe<Array<InputMaybe<ClaimDiagnosisInput>>>;
  endDateOfService?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  initialReferringProvider?: InputMaybe<ReferringProviderInput>;
  onsetOfCurrentIllnessOrSymptomDate?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<ClaimPatientInput>;
  patientAuthorizedRelease?: InputMaybe<Scalars['Boolean']['input']>;
  payToAddress?: InputMaybe<AddressInput>;
  placeOfServiceCode?: InputMaybe<Scalars['String']['input']>;
  providerAcceptsAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  referringProvider?: InputMaybe<ReferringProviderInput>;
  renderingProvider?: InputMaybe<ClaimProviderInput>;
  responsibleParty?: InputMaybe<Scalars['String']['input']>;
  serviceLines?: InputMaybe<Array<InputMaybe<ServiceLineInput>>>;
  subscriberPrimary?: InputMaybe<SubscriberInput>;
  subscriberSecondary?: InputMaybe<SubscriberInput>;
  synchronicity?: InputMaybe<Scalars['String']['input']>;
}

export interface AddConversationInput {
  participants?: InputMaybe<Scalars['AWSJSON']['input']>;
  patientFirstName?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
  patientLastName?: InputMaybe<Scalars['String']['input']>;
  providerAvatar?: InputMaybe<Scalars['String']['input']>;
  providerFirstName?: InputMaybe<Scalars['String']['input']>;
  providerLastName?: InputMaybe<Scalars['String']['input']>;
  ptId: Scalars['ID']['input'];
  senders?: InputMaybe<Scalars['AWSJSON']['input']>;
}

export interface AddExamFormInput {
  bodyPositionTags?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyRegionTags?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyRegionsApplied?: InputMaybe<Array<Scalars['String']['input']>>;
  bodySegmentTags?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  creatorId: Scalars['ID']['input'];
  diagnosisTags?: InputMaybe<Array<Scalars['String']['input']>>;
  examFormStatus?: InputMaybe<Array<ExamFormStatusInput>>;
  examFormTests: Array<ExamFormTestInput>;
  examTitle: Scalars['String']['input'];
  familyTags?: InputMaybe<Array<Scalars['String']['input']>>;
  familyTagsOrder?: InputMaybe<Array<FamilyTagOrderInput>>;
  formFinished?: InputMaybe<Scalars['Boolean']['input']>;
  functionTags?: InputMaybe<Array<Scalars['String']['input']>>;
  levelTags?: InputMaybe<Array<Scalars['String']['input']>>;
  modifiedAt: Scalars['AWSDateTime']['input'];
  triageSetTags?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface AddInAppNotificationInput {
  message: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: InAppNotificationType;
  userId: Scalars['ID']['input'];
}

export interface AddNonEligibleUserInput {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  howDidYouHearFromUs?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  submittedAt: Scalars['AWSDateTime']['input'];
}

export interface AddProviderInput {
  appointments?: InputMaybe<Array<AddAppointmentInput>>;
  createdOn?: InputMaybe<Scalars['AWSDateTime']['input']>;
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  introBio?: InputMaybe<Scalars['String']['input']>;
  licenseState: Array<Scalars['String']['input']>;
  practiceLocations?: InputMaybe<Array<PracticeLocationInput>>;
  ptSince?: InputMaybe<Scalars['AWSDateTime']['input']>;
  unavailableHours: Array<UnavailableHourInput>;
  userGroup: UserGroup;
  userPreferences: AddProviderUserPreferencesInput;
  workingHours: Array<InputMaybe<TimeRangeInput>>;
}

export interface AddProviderUserPreferencesInput {
  appointmentGap: AppointmentGap;
  notificationPreferences?: InputMaybe<Array<NotificationPreferenceInput>>;
}

export interface Address {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
  zipPlusFourCode?: Maybe<Scalars['String']['output']>;
}

export interface AddressInput {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  zipPlusFourCode?: InputMaybe<Scalars['String']['input']>;
}

export interface AddressSuggestion {
  __typename?: 'AddressSuggestion';
  label: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
}

export interface AdminListCognitoUsersInput {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  userGroup?: InputMaybe<UserGroup>;
}

export interface AdminListCognitoUsersResponse {
  __typename?: 'AdminListCognitoUsersResponse';
  items: Array<UserAttribute>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface AdminPermissions {
  __typename?: 'AdminPermissions';
  examForms?: Maybe<PermissionCrud>;
  familyTags?: Maybe<PermissionCrud>;
  patients?: Maybe<PermissionCrud>;
  referrals?: Maybe<PermissionCrud>;
}

export interface AdminPermissionsInput {
  examForms?: InputMaybe<PermissionCrudInput>;
  familyTags?: InputMaybe<PermissionCrudInput>;
  patients?: InputMaybe<PermissionCrudInput>;
  referrals?: InputMaybe<PermissionCrudInput>;
}

export interface AdminSearchPatientPickerInput {
  /** 1-indexed. */
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  /** Substring of "first last", email or MRN; empty lists everyone. */
  search?: InputMaybe<Scalars['String']['input']>;
}

export interface AdminSearchPatientPickerResponse {
  __typename?: 'AdminSearchPatientPickerResponse';
  patients: Array<PatientPickerEntry>;
  total: Scalars['Int']['output'];
}

export interface AdminUser {
  __typename?: 'AdminUser';
  createdOn: Scalars['AWSDateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  permissions?: Maybe<AdminPermissions>;
  userGroup: UserGroup;
}

export interface AdminUserAttribute {
  __typename?: 'AdminUserAttribute';
  email: Scalars['String']['output'];
  family_name: Scalars['String']['output'];
  given_name: Scalars['String']['output'];
  sub: Scalars['String']['output'];
}

export interface AffectedBodyRegion {
  __typename?: 'AffectedBodyRegion';
  bodyRegion: BodyPartType;
}

export interface AllergenOption {
  __typename?: 'AllergenOption';
  display: Scalars['String']['output'];
  fdbCode: Scalars['String']['output'];
  rxnormCode?: Maybe<Scalars['String']['output']>;
}

export interface AllergyInput {
  display: Scalars['String']['input'];
  fdbCode: Scalars['String']['input'];
  rxnormCode?: InputMaybe<Scalars['String']['input']>;
}

export interface Appointment {
  __typename?: 'Appointment';
  appointmentDate: Scalars['AWSDateTime']['output'];
  appointmentStatus: AppointmentStatus;
  appointmentType: AppointmentType;
  canvasAppointmentId?: Maybe<Scalars['String']['output']>;
  canvasAppointmentStatus?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  episodeOfCareId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  patient: ClientUser;
  patientId: Scalars['ID']['output'];
  provider: ProviderUser;
  ptId: Scalars['ID']['output'];
  scheduledStart?: Maybe<Scalars['AWSDateTime']['output']>;
  soap: Soap;
}

export interface AppointmentCallStatus {
  __typename?: 'AppointmentCallStatus';
  canvasAppointmentId: Scalars['ID']['output'];
  canvasAppointmentStatus?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  videoSessionStartTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
}

export enum AppointmentGap {
  FifteenMin = 'FifteenMin',
  None = 'None',
  ThirtyMin = 'ThirtyMin'
}

export interface AppointmentReportInput {
  appointmentDate: Scalars['AWSDateTime']['input'];
  ptId: Scalars['ID']['input'];
}

export interface AppointmentSchedulingInfo {
  __typename?: 'AppointmentSchedulingInfo';
  appointmentDateTime: Scalars['AWSDateTime']['output'];
  appointmentState: Scalars['String']['output'];
  ptId?: Maybe<Scalars['ID']['output']>;
  scheduledBy: Scalars['ID']['output'];
  schedulerGroup: UserGroup;
  userTimezone: Scalars['String']['output'];
}

export interface AppointmentSchedulingInfoInput {
  appointmentDateTime: Scalars['AWSDateTime']['input'];
  appointmentState: Scalars['String']['input'];
  ptId: Scalars['ID']['input'];
  scheduledBy: Scalars['ID']['input'];
  schedulerGroup: UserGroup;
  userTimezone: Scalars['String']['input'];
}

export enum AppointmentStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Confirmed = 'Confirmed',
  Missed = 'Missed',
  PostTriage = 'PostTriage',
  Ready = 'Ready',
  Scheduled = 'Scheduled'
}

export enum AppointmentType {
  FollowUp = 'FollowUp',
  Placeholder = 'Placeholder',
  Triage = 'Triage'
}

export enum AppointmentVariant {
  Phone = 'Phone',
  Virtual = 'Virtual'
}

export interface AppointmentsConnection {
  __typename?: 'AppointmentsConnection';
  items: Array<Appointment>;
  limit?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface AppointmentsFilterInput {
  appointmentDate?: InputMaybe<StringFilterInput>;
}

export interface Assessment {
  __typename?: 'Assessment';
  providerNotes: Scalars['String']['output'];
}

export interface AssessmentInput {
  providerNotes: Scalars['String']['input'];
}

export interface Bill {
  __typename?: 'Bill';
  amountPerCategory?: Maybe<Array<SingleCategoryPrice>>;
  appointmentId: Scalars['ID']['output'];
  claimId?: Maybe<Scalars['ID']['output']>;
  coinsurance: Scalars['String']['output'];
  createdOn: Scalars['AWSDateTime']['output'];
  deductible: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  patientId: Scalars['ID']['output'];
  patientResponsibility: Scalars['String']['output'];
  paymentMethodBilled?: Maybe<PaymentMethodBilled>;
  totalAmount: Scalars['String']['output'];
}

export enum BillReasonType {
  Coinsurance = 'COINSURANCE',
  Copay = 'COPAY',
  Paidinfull = 'PAIDINFULL'
}

export interface BillingCategory {
  __typename?: 'BillingCategory';
  code: CptCode;
  details: Scalars['String']['output'];
  timeInMinutes: Scalars['Int']['output'];
  units: Scalars['Int']['output'];
}

export interface BillingCategoryInput {
  code: CptCodeInput;
  details: Scalars['String']['input'];
  timeInMinutes: Scalars['Int']['input'];
  units: Scalars['Int']['input'];
}

export enum BodyPartType {
  Buttocks = 'Buttocks',
  LeftAnkle = 'Left_Ankle',
  LeftElbow = 'Left_Elbow',
  LeftFoot = 'Left_Foot',
  LeftForearm = 'Left_Forearm',
  LeftHand = 'Left_Hand',
  LeftHip = 'Left_Hip',
  LeftKnee = 'Left_Knee',
  LeftLowerLeg = 'Left_Lower_Leg',
  LeftShoulder = 'Left_Shoulder',
  LeftUpperArm = 'Left_Upper_Arm',
  LeftUpperLeg = 'Left_Upper_Leg',
  LeftWrist = 'Left_Wrist',
  LowerBack = 'Lower_Back',
  Neck = 'Neck',
  RightAnkle = 'Right_Ankle',
  RightElbow = 'Right_Elbow',
  RightFoot = 'Right_Foot',
  RightForearm = 'Right_Forearm',
  RightHand = 'Right_Hand',
  RightHip = 'Right_Hip',
  RightKnee = 'Right_Knee',
  RightLowerLeg = 'Right_Lower_Leg',
  RightShoulder = 'Right_Shoulder',
  RightUpperArm = 'Right_Upper_Arm',
  RightUpperLeg = 'Right_Upper_Leg',
  RightWrist = 'Right_Wrist',
  UpperBack = 'Upper_Back'
}

export enum BodyRegion {
  Ankle = 'Ankle',
  Buttocks = 'Buttocks',
  Elbow = 'Elbow',
  Foot = 'Foot',
  Forearm = 'Forearm',
  Hand = 'Hand',
  Hip = 'Hip',
  Knee = 'Knee',
  LowerBack = 'Lower_Back',
  LowerLeg = 'Lower_Leg',
  Neck = 'Neck',
  Shoulder = 'Shoulder',
  UpperArm = 'Upper_Arm',
  UpperBack = 'Upper_Back',
  UpperLeg = 'Upper_Leg',
  Wrist = 'Wrist'
}

export enum BodySideType {
  Left = 'Left',
  Right = 'Right'
}

export interface CmsTag {
  __typename?: 'CMSTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface CmsVideo {
  __typename?: 'CMSVideo';
  bodyPositionTags?: Maybe<Array<CmsTag>>;
  bodyRegionTags?: Maybe<Array<CmsTag>>;
  diagnosisTags?: Maybe<Array<CmsTag>>;
  howTo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  preview?: Maybe<CmsVideoPreview>;
  subtitles?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  videoFile?: Maybe<CmsVideoFile>;
}

export interface CmsVideoFile {
  __typename?: 'CMSVideoFile';
  filename: Scalars['String']['output'];
  filesize: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
}

export interface CmsVideoPreview {
  __typename?: 'CMSVideoPreview';
  extension: Scalars['String']['output'];
  filesize: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  width: Scalars['Int']['output'];
}

export interface CancelAppointmentByCanvasIdInput {
  canvasAppointmentId: Scalars['ID']['input'];
  reason?: InputMaybe<CancellationReason>;
  reasonNote?: InputMaybe<Scalars['String']['input']>;
}

export interface CancelCanvasPhoneAppointmentInput {
  canvasAppointmentId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}

export interface CancelCanvasTriageAppointmentInput {
  appointmentId: Scalars['ID']['input'];
}

export enum CancellationReason {
  CareElsewhere = 'care_elsewhere',
  CostOrInsurance = 'cost_or_insurance',
  Other = 'other',
  PainImproved = 'pain_improved',
  SchedulingConflict = 'scheduling_conflict',
  Sick = 'sick'
}

export interface CancelledAppointmentTransactions {
  __typename?: 'CancelledAppointmentTransactions';
  appointmentDateTime: Scalars['AWSDateTime']['output'];
  appointmentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ptId: Scalars['String']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
}

export interface CancerData {
  __typename?: 'CancerData';
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
}

export interface CancerSectionInput {
  status: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}

export enum CandidHealthGender {
  Female = 'female',
  Male = 'male',
  NotGiven = 'not_given',
  Other = 'other',
  Unknown = 'unknown'
}

export enum CandidHealthPhoneType {
  Home = 'Home',
  Mobile = 'Mobile',
  Work = 'Work'
}

export interface CanvasAppointmentData {
  __typename?: 'CanvasAppointmentData';
  appointmentDateTime: Scalars['AWSDateTime']['output'];
  appointmentId?: Maybe<Scalars['String']['output']>;
  appointmentReason: Scalars['String']['output'];
  appointmentState: Scalars['String']['output'];
  appointmentStatus: Scalars['String']['output'];
  canvasAppointmentId: Scalars['String']['output'];
  canvasProviderId: Scalars['String']['output'];
  diagnosis?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  evaluationNoteId?: Maybe<Scalars['String']['output']>;
  followUpWeeks?: Maybe<Scalars['Int']['output']>;
  followUpsPerWeek?: Maybe<Scalars['Int']['output']>;
  noteId?: Maybe<Scalars['String']['output']>;
  noteState?: Maybe<Scalars['String']['output']>;
  noteType?: Maybe<Scalars['String']['output']>;
  ptId: Scalars['String']['output'];
  recommendedFollowUps?: Maybe<Scalars['Int']['output']>;
  variant: AppointmentVariant;
}

export interface CanvasAppointmentEvent {
  __typename?: 'CanvasAppointmentEvent';
  appointmentId?: Maybe<Scalars['String']['output']>;
  appointmentReason: Scalars['String']['output'];
  appointmentType: Scalars['String']['output'];
  canvasAppointmentId: Scalars['String']['output'];
  end: Scalars['AWSDateTime']['output'];
  episodeOfCareId?: Maybe<Scalars['String']['output']>;
  patientFirstName: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  patientLastName: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  start: Scalars['AWSDateTime']['output'];
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
}

export enum CanvasNoteTypeCode {
  MedicalConsult = 'MEDICAL_CONSULT',
  PhoneConsult = 'PHONE_CONSULT',
  PhoneEvaluation = 'PHONE_EVALUATION',
  PtCheckIn = 'PT_CHECK_IN',
  PtFollowUp = 'PT_FOLLOW_UP',
  VirtualEvaluation = 'VIRTUAL_EVALUATION'
}

export interface CanvasSchedulerData {
  __typename?: 'CanvasSchedulerData';
  appointmentDateTime: Scalars['AWSDateTime']['output'];
  appointmentId: Scalars['String']['output'];
  canvasAppointmentId: Scalars['String']['output'];
  canvasPractitionerId: Scalars['String']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
}

export interface CanvasSchedulerError {
  __typename?: 'CanvasSchedulerError';
  details?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
  type: CanvasSchedulerErrorType;
}

export enum CanvasSchedulerErrorType {
  AccessDenied = 'AccessDenied',
  AppointmentTimePassed = 'AppointmentTimePassed',
  InvalidInput = 'InvalidInput',
  ResourceExists = 'ResourceExists',
  ResourceNotFound = 'ResourceNotFound',
  ServerError = 'ServerError',
  SlotUnavailable = 'SlotUnavailable',
  Unconfirmed = 'Unconfirmed'
}

export interface CanvasSchedulerResponse {
  __typename?: 'CanvasSchedulerResponse';
  data?: Maybe<CanvasSchedulerData>;
  error?: Maybe<CanvasSchedulerError>;
  success: Scalars['Boolean']['output'];
}

export interface CareGoal {
  __typename?: 'CareGoal';
  completed: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
}

export interface CarePlanExercises {
  __typename?: 'CarePlanExercises';
  days: Array<ExerciseDay>;
}

export interface CarePlanExercisesInput {
  days: Array<ExerciseDayInput>;
}

export interface CarePlanInformation {
  __typename?: 'CarePlanInformation';
  generalInstructions: Scalars['String']['output'];
  goals?: Maybe<Array<CareGoal>>;
}

export interface CarePlanInformationInput {
  generalInstructions: Scalars['String']['input'];
  goals?: InputMaybe<Array<GoalInput>>;
}

export interface CareTeamMember {
  __typename?: 'CareTeamMember';
  canvasPractitionerId: Scalars['ID']['output'];
  displayName: Scalars['String']['output'];
}

export interface ChatConnection {
  __typename?: 'ChatConnection';
  items?: Maybe<Array<Maybe<ChatMessage>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface ChatMessage {
  __typename?: 'ChatMessage';
  attachmentRefs?: Maybe<Array<Maybe<File>>>;
  conversationId: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  pinnedByPT?: Maybe<Scalars['Boolean']['output']>;
  pinnedByPatient?: Maybe<Scalars['Boolean']['output']>;
  recipientId: Scalars['ID']['output'];
  senderCanvasStaffId?: Maybe<Scalars['ID']['output']>;
  senderDisplayName?: Maybe<Scalars['String']['output']>;
  senderId: Scalars['ID']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
}

export interface Claim {
  __typename?: 'Claim';
  appointmentId: Scalars['ID']['output'];
  benefitsAssignedToProvider?: Maybe<Scalars['Boolean']['output']>;
  billableStatus?: Maybe<Scalars['String']['output']>;
  billingProvider?: Maybe<ClaimProvider>;
  candidUrl?: Maybe<Scalars['String']['output']>;
  claimStatus?: Maybe<ClaimStatus>;
  dateOfService?: Maybe<Scalars['String']['output']>;
  diagnoses?: Maybe<Array<Maybe<ClaimDiagnosis>>>;
  encounterId?: Maybe<Scalars['String']['output']>;
  endDateOfService?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  initialReferringProvider?: Maybe<ReferringProvider>;
  onsetOfCurrentIllnessOrSymptomDate?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<ClaimPatient>;
  patientAuthorizedRelease?: Maybe<Scalars['Boolean']['output']>;
  payToAddress?: Maybe<Address>;
  placeOfServiceCode?: Maybe<Scalars['String']['output']>;
  providerAcceptsAssignment?: Maybe<Scalars['Boolean']['output']>;
  referringProvider?: Maybe<ReferringProvider>;
  renderingProvider?: Maybe<ClaimProvider>;
  responsibleParty?: Maybe<Scalars['String']['output']>;
  serviceLines?: Maybe<Array<Maybe<ServiceLine>>>;
  statusReason?: Maybe<Scalars['String']['output']>;
  statusUpdatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  submittedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  subscriberPrimary?: Maybe<Subscriber>;
  subscriberSecondary?: Maybe<Subscriber>;
  synchronicity?: Maybe<Scalars['String']['output']>;
}

export interface ClaimDiagnosis {
  __typename?: 'ClaimDiagnosis';
  code?: Maybe<Scalars['String']['output']>;
  codeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
}

export interface ClaimDiagnosisInput {
  code?: InputMaybe<Scalars['String']['input']>;
  codeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface ClaimPatient {
  __typename?: 'ClaimPatient';
  address?: Maybe<Address>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailConsent?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<CandidHealthGender>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  phoneConsent?: Maybe<Scalars['Boolean']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumber>>>;
}

export interface ClaimPatientInput {
  address?: InputMaybe<AddressInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailConsent?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<CandidHealthGender>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneConsent?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
}

export interface ClaimProvider {
  __typename?: 'ClaimProvider';
  address?: Maybe<Address>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
}

export interface ClaimProviderInput {
  address?: InputMaybe<AddressInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  npi?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
}

export enum ClaimStatus {
  Draft = 'Draft',
  Failed = 'Failed',
  Skipped = 'Skipped',
  Submitted = 'Submitted'
}

export interface ClientUser {
  __typename?: 'ClientUser';
  acceptedConsentAgreement?: Maybe<Scalars['Boolean']['output']>;
  acceptedConsentToCommunicate?: Maybe<Scalars['Boolean']['output']>;
  acceptedHIPAAPrivacyNotice?: Maybe<Scalars['Boolean']['output']>;
  acceptedPaymentTerms?: Maybe<Scalars['Boolean']['output']>;
  acceptedTermsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  canvasPatientId?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['AWSDateTime']['output'];
  dob: Scalars['AWSDate']['output'];
  email: Scalars['String']['output'];
  emergencyContact?: Maybe<EmergencyContact>;
  episodesOfCare?: Maybe<Array<EpisodeOfCare>>;
  firstName: Scalars['String']['output'];
  /** @deprecated Use sex field instead */
  gender?: Maybe<Gender>;
  height?: Maybe<Height>;
  homeAddress: HomeAddress;
  id: Scalars['ID']['output'];
  insurances?: Maybe<Array<Maybe<InsuranceItem>>>;
  lastName: Scalars['String']['output'];
  localTimeZone?: Maybe<Scalars['String']['output']>;
  medicalRecordNumber?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  patientSummary?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer used */
  pronouns?: Maybe<Pronouns>;
  sex?: Maybe<Sex>;
  weight?: Maybe<Scalars['Int']['output']>;
}

export interface ClientUserAttribute {
  __typename?: 'ClientUserAttribute';
  birthdate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  email: Scalars['String']['output'];
  family_name: Scalars['String']['output'];
  given_name: Scalars['String']['output'];
  medicalRecordNumber: Scalars['String']['output'];
  onboardStatus: Scalars['String']['output'];
  referralId: Scalars['String']['output'];
  sub: Scalars['String']['output'];
}

export interface ClientsResponse {
  __typename?: 'ClientsResponse';
  items: Array<ClientUser>;
  limit?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum ClinicalReportType {
  Appointment = 'Appointment',
  Discharge = 'Discharge',
  PhysicalTherapyNote = 'PhysicalTherapyNote'
}

export interface CompleteEpisodeOfCareInput {
  comments?: InputMaybe<Scalars['String']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
}

export interface CompleteOnboardingV2Input {
  patientId: Scalars['ID']['input'];
}

export interface ConcludeVisitInput {
  canvasAppointmentId: Scalars['ID']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  reason: ConcludeVisitReason;
}

export enum ConcludeVisitReason {
  CantContinue = 'CantContinue',
  Ineligible = 'Ineligible',
  MedicalEmergency = 'MedicalEmergency',
  Missed = 'Missed',
  Other = 'Other',
  SessionCompleted = 'SessionCompleted',
  WrongState = 'WrongState'
}

export enum ConditionClinicalStatus {
  Active = 'active',
  Relapse = 'relapse',
  Remission = 'remission',
  Resolved = 'resolved'
}

export interface ConditionDetails {
  __typename?: 'ConditionDetails';
  bodyRegion: BodyPartType;
  canBearWeight?: Maybe<Scalars['Boolean']['output']>;
  incidentDetails: Scalars['String']['output'];
  incidentOccurredOn: Scalars['AWSDate']['output'];
  isAccidentOrInjuryRelated: Scalars['Boolean']['output'];
}

export interface ConditionDetailsData {
  __typename?: 'ConditionDetailsData';
  bodyPart?: Maybe<BodyPartType>;
  feeling?: Maybe<Scalars['String']['output']>;
  hadAccident?: Maybe<Scalars['Boolean']['output']>;
  onOpioidMedication?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  treatmentGoal?: Maybe<Scalars['String']['output']>;
  triggerActivity?: Maybe<Scalars['String']['output']>;
  usingPainMedication?: Maybe<Scalars['Boolean']['output']>;
}

export interface ConditionDetailsInput {
  bodyRegion: BodyPartType;
  canBearWeight?: InputMaybe<Scalars['Boolean']['input']>;
  incidentDetails: Scalars['String']['input'];
  incidentOccurredOn: Scalars['AWSDate']['input'];
  isAccidentOrInjuryRelated: Scalars['Boolean']['input'];
}

export interface ConditionDetailsSectionInput {
  bodyPart: BodyPartType;
  feeling: Scalars['String']['input'];
  hadAccident: Scalars['Boolean']['input'];
  onOpioidMedication: Scalars['Boolean']['input'];
  startDate: Scalars['String']['input'];
  treatmentGoal: Scalars['String']['input'];
  triggerActivity: Scalars['String']['input'];
  usingPainMedication: Scalars['Boolean']['input'];
}

export enum ConditionalStyleRendering {
  Column = 'Column',
  Row = 'Row'
}

export interface ConsentsData {
  __typename?: 'ConsentsData';
  acceptedCodes: Array<Scalars['String']['output']>;
}

export interface ConsentsInput {
  acceptedCodes: Array<Scalars['String']['input']>;
}

export interface Conversation {
  __typename?: 'Conversation';
  attachmentRefs?: Maybe<Array<Maybe<File>>>;
  conversationId: Scalars['ID']['output'];
  currentPtId?: Maybe<Scalars['ID']['output']>;
  lastMessage?: Maybe<ChatMessage>;
  lastMessageTimestamp: Scalars['AWSDateTime']['output'];
  lastSeenByPT: Scalars['AWSDateTime']['output'];
  lastSeenByPatient: Scalars['AWSDateTime']['output'];
  participants?: Maybe<Scalars['AWSJSON']['output']>;
  patient?: Maybe<ClientUser>;
  patientFirstName: Scalars['String']['output'];
  patientId: Scalars['ID']['output'];
  patientLastName: Scalars['String']['output'];
  provider?: Maybe<ProviderUser>;
  providerAvatar?: Maybe<Scalars['String']['output']>;
  providerFirstName: Scalars['String']['output'];
  providerLastName: Scalars['String']['output'];
  ptId: Scalars['ID']['output'];
  ptWithAccess?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  seenBy?: Maybe<Scalars['AWSJSON']['output']>;
  senders?: Maybe<Scalars['AWSJSON']['output']>;
}

export interface ConversationsConnection {
  __typename?: 'ConversationsConnection';
  items?: Maybe<Array<Maybe<Conversation>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export enum CoverageStatus {
  FullyCovered = 'FullyCovered',
  NotCovered = 'NotCovered',
  PartiallyCovered = 'PartiallyCovered'
}

export interface CptCode {
  __typename?: 'CptCode';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  unit: Scalars['Int']['output'];
}

export interface CptCodeInput {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  unit: Scalars['Int']['input'];
}

export interface CptCodesResponse {
  __typename?: 'CptCodesResponse';
  codes: Array<CptCode>;
}

export interface CreateAccommodationFormInput {
  episodeOfCareId?: InputMaybe<Scalars['ID']['input']>;
  formData: Scalars['AWSJSON']['input'];
  patientId: Scalars['ID']['input'];
}

export interface CreateAdminReferralInput {
  createReferralInput: CreateReferralInput;
  referralId: Scalars['ID']['input'];
}

export interface CreateAdminReferralResponse {
  __typename?: 'CreateAdminReferralResponse';
  canvasPatientId?: Maybe<Scalars['String']['output']>;
  errorMsg?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
}

export interface CreateCanvasFollowUpAppointmentInput {
  appointmentDateTime: Scalars['AWSDateTime']['input'];
  episodeOfCareId: Scalars['ID']['input'];
}

export interface CreateCanvasPhoneAppointmentInput {
  appointmentDateTime: Scalars['AWSDateTime']['input'];
  appointmentReason: Scalars['String']['input'];
  appointmentState: Scalars['String']['input'];
  canvasPractitionerId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}

export interface CreateCanvasTriageAppointmentInput {
  appointmentDateTime: Scalars['AWSDateTime']['input'];
  appointmentState: Scalars['String']['input'];
  canvasPractitionerId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}

export interface CreateFollowUpPromsInput {
  followUpAssigned: Scalars['Int']['input'];
}

export interface CreateReferralInput {
  hubspotContactId?: InputMaybe<Scalars['String']['input']>;
  initiatedBy: UserGroup;
  insuranceInfo: InsuranceInfoInput;
  intakeSource: IntakeSource;
  patientEligibility: PatientEligibilityInput;
  patientProfile: PatientProfileInput;
  referralDetails?: InputMaybe<ReferralDetailsInput>;
}

export enum Currency {
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

export interface DateRange {
  __typename?: 'DateRange';
  from: Scalars['AWSDate']['output'];
  to: Scalars['AWSDate']['output'];
}

export interface DateRangeInput {
  from: Scalars['AWSDate']['input'];
  to: Scalars['AWSDate']['input'];
}

export interface DateTimeFilterInput {
  beginsWith?: InputMaybe<Scalars['AWSDateTime']['input']>;
  between?: InputMaybe<Array<Scalars['AWSDateTime']['input']>>;
}

export interface DateTimeRange {
  __typename?: 'DateTimeRange';
  from: Scalars['AWSDateTime']['output'];
  to: Scalars['AWSDateTime']['output'];
}

export interface DateTimeRangeInput {
  from: Scalars['AWSDateTime']['input'];
  to: Scalars['AWSDateTime']['input'];
}

export interface Deductible {
  __typename?: 'Deductible';
  family?: Maybe<Scalars['Float']['output']>;
  individual?: Maybe<Scalars['Float']['output']>;
}

export interface DepressionRecord {
  __typename?: 'DepressionRecord';
  feelingBadAboutSelf?: Maybe<Scalars['Int']['output']>;
  feelingDownDepressedOrHopeless: Scalars['Int']['output'];
  feelingTiredOrLittleEnergy?: Maybe<Scalars['Int']['output']>;
  littleInterestInDoingThings: Scalars['Int']['output'];
  poorAppetiteOrOverEating?: Maybe<Scalars['Int']['output']>;
  psychomotorChanges?: Maybe<Scalars['Int']['output']>;
  sleepIssues?: Maybe<Scalars['Int']['output']>;
  suicidalThoughts?: Maybe<Scalars['Int']['output']>;
  troubleConcentrating?: Maybe<Scalars['Int']['output']>;
}

export interface DepressionRecordInput {
  feelingBadAboutSelf?: InputMaybe<Scalars['Int']['input']>;
  feelingDownDepressedOrHopeless: Scalars['Int']['input'];
  feelingTiredOrLittleEnergy?: InputMaybe<Scalars['Int']['input']>;
  littleInterestInDoingThings: Scalars['Int']['input'];
  poorAppetiteOrOverEating?: InputMaybe<Scalars['Int']['input']>;
  psychomotorChanges?: InputMaybe<Scalars['Int']['input']>;
  sleepIssues?: InputMaybe<Scalars['Int']['input']>;
  suicidalThoughts?: InputMaybe<Scalars['Int']['input']>;
  troubleConcentrating?: InputMaybe<Scalars['Int']['input']>;
}

export enum DischargeReason {
  DiscontinuedInsurance = 'DiscontinuedInsurance',
  FinishedCare = 'FinishedCare',
  Other = 'Other',
  PatientDidNotReturn = 'PatientDidNotReturn',
  PatientReachedPtGoals = 'PatientReachedPTGoals',
  PatientReferredToOutsideProvider = 'PatientReferredToOutsideProvider',
  TriageVisitCancelled = 'TriageVisitCancelled'
}

export interface DischargeReportInput {
  episodeOfCareId: Scalars['ID']['input'];
}

export interface DischargeStatus {
  __typename?: 'DischargeStatus';
  comments?: Maybe<Scalars['String']['output']>;
  dischargeDate: Scalars['AWSDateTime']['output'];
  reason: DischargeReason;
}

export interface EmailResponse {
  __typename?: 'EmailResponse';
  message: Scalars['String']['output'];
}

export interface EmergencyContact {
  __typename?: 'EmergencyContact';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  relationship: Scalars['String']['output'];
}

export interface EmergencyContactData {
  __typename?: 'EmergencyContactData';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
}

export interface EmergencyContactInput {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  relationship: Scalars['String']['input'];
}

export interface EmergencyContactSectionInput {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  relationship: Scalars['String']['input'];
}

export enum EmployerOrWorkplace {
  Amazon = 'Amazon',
  Other = 'Other'
}

export interface EpisodeOfCare {
  __typename?: 'EpisodeOfCare';
  appointmentState: Scalars['String']['output'];
  appointments: Array<Appointment>;
  assignedFollowUp?: Maybe<Scalars['Int']['output']>;
  assignedFollowUpPerWeek?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['AWSDateTime']['output'];
  diagnosis?: Maybe<Scalars['String']['output']>;
  dischargeStatus?: Maybe<DischargeStatus>;
  episodeComplete?: Maybe<Scalars['Boolean']['output']>;
  episodeOfCareId: Scalars['ID']['output'];
  incident?: Maybe<IncidentTypes>;
  patient?: Maybe<ClientUser>;
  patientId: Scalars['ID']['output'];
  prom?: Maybe<EpisodeOfCareProm>;
  promQR?: Maybe<EpisodeOfCarePromQr>;
  ptId: Scalars['ID']['output'];
  referralHistory?: Maybe<ReferralHistory>;
  referralHistoryId?: Maybe<Scalars['ID']['output']>;
  soap: Soap;
}

export interface EpisodeOfCareConnection {
  __typename?: 'EpisodeOfCareConnection';
  items: Array<EpisodeOfCare>;
  limit?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface EpisodeOfCareProm {
  __typename?: 'EpisodeOfCareProm';
  createdAt: Scalars['AWSDateTime']['output'];
  promItems: Array<PromItem>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
}

export interface EpisodeOfCarePromQr {
  __typename?: 'EpisodeOfCarePromQR';
  lastPromRemindedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  promRequestAt?: Maybe<Scalars['AWSDateTime']['output']>;
  responses: Array<PromQrResponse>;
}

export interface ExamForm {
  __typename?: 'ExamForm';
  bodyPositionTags?: Maybe<Array<Scalars['String']['output']>>;
  bodyRegionTags?: Maybe<Array<Scalars['String']['output']>>;
  bodyRegionsApplied?: Maybe<Array<Scalars['String']['output']>>;
  bodySegmentTags?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['AWSDateTime']['output'];
  creatorId: Scalars['ID']['output'];
  diagnosisTags?: Maybe<Array<Scalars['String']['output']>>;
  examFormId: Scalars['ID']['output'];
  examFormStatus?: Maybe<Array<ExamFormStatus>>;
  examFormTests: Array<ExamFormTest>;
  examTitle: Scalars['String']['output'];
  familyTags?: Maybe<Array<Scalars['String']['output']>>;
  familyTagsOrder?: Maybe<Array<ExamFormFamilyTagOrder>>;
  formFinished?: Maybe<Scalars['Boolean']['output']>;
  functionTags?: Maybe<Array<Scalars['String']['output']>>;
  levelTags?: Maybe<Array<Scalars['String']['output']>>;
  modifiedAt: Scalars['AWSDateTime']['output'];
  triageSetTags?: Maybe<Array<Scalars['String']['output']>>;
}

export interface ExamFormChoiceAnswer {
  __typename?: 'ExamFormChoiceAnswer';
  addInputText?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inputPlaceholder?: Maybe<Scalars['String']['output']>;
  inputTextSize?: Maybe<ExamFormChoiceRowInputSize>;
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  rowTitle?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
}

export interface ExamFormChoiceInput {
  addInputText: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inputPlaceholder?: InputMaybe<Scalars['String']['input']>;
  inputTextSize?: InputMaybe<ExamFormChoiceRowInputSize>;
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  rowTitle: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
}

export interface ExamFormChoiceRow {
  __typename?: 'ExamFormChoiceRow';
  addInputText?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  inputPlaceholder?: Maybe<Scalars['String']['output']>;
  inputTextSize?: Maybe<ExamFormChoiceRowInputSize>;
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  rowTitle: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
}

export interface ExamFormChoiceRowInput {
  addInputText: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  inputPlaceholder?: InputMaybe<Scalars['String']['input']>;
  inputTextSize?: InputMaybe<ExamFormChoiceRowInputSize>;
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  rowTitle: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
}

export enum ExamFormChoiceRowInputSize {
  Fill = 'Fill',
  Full = 'Full',
  Half = 'Half'
}

export enum ExamFormChoiceType {
  BinaryChoice = 'BinaryChoice',
  MultipleChoice = 'MultipleChoice',
  MultipleSelect = 'MultipleSelect',
  MultipleSelectDropdown = 'MultipleSelectDropdown',
  PosNegChoice = 'PosNegChoice',
  YesNoChoice = 'YesNoChoice'
}

export interface ExamFormDataInputAnswer {
  __typename?: 'ExamFormDataInputAnswer';
  inputValueBoolean?: Maybe<Scalars['Boolean']['output']>;
  inputValueDegrees?: Maybe<Scalars['Float']['output']>;
  inputValueMultiSelect?: Maybe<Array<Scalars['String']['output']>>;
  inputValueNumber?: Maybe<Scalars['Float']['output']>;
  inputValueOneToTenSplitButton?: Maybe<Scalars['Int']['output']>;
  inputValuePercent?: Maybe<Scalars['Float']['output']>;
  inputValuePosNeg?: Maybe<PosNegEnum>;
  inputValueSeconds?: Maybe<Scalars['Float']['output']>;
  inputValueTemp?: Maybe<Scalars['Float']['output']>;
  inputValueText?: Maybe<Scalars['String']['output']>;
  inputValueYesNo?: Maybe<Scalars['Boolean']['output']>;
}

export interface ExamFormDataInputColumnAnswerInput {
  inputValueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  inputValueDegrees?: InputMaybe<Scalars['Float']['input']>;
  inputValueMultiSelect?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inputValueNumber?: InputMaybe<Scalars['Float']['input']>;
  inputValuePercent?: InputMaybe<Scalars['Float']['input']>;
  inputValuePosNeg?: InputMaybe<PosNegEnum>;
  inputValueSeconds?: InputMaybe<Scalars['Float']['input']>;
  inputValueTemp?: InputMaybe<Scalars['Float']['input']>;
  inputValueText?: InputMaybe<Scalars['String']['input']>;
  inputValueYesNo?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface ExamFormDataInputRow {
  __typename?: 'ExamFormDataInputRow';
  addInputText?: Maybe<Scalars['Boolean']['output']>;
  examFormDataInputRowType: ExamFormDataInputRowType;
  id: Scalars['String']['output'];
  inputPlaceholder?: Maybe<Scalars['String']['output']>;
  inputValue?: Maybe<Scalars['String']['output']>;
  isTextArea?: Maybe<Scalars['Boolean']['output']>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  maxLabel?: Maybe<Scalars['String']['output']>;
  minLabel?: Maybe<Scalars['String']['output']>;
  rowTitle?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
}

export interface ExamFormDataInputRowInput {
  addInputText?: InputMaybe<Scalars['Boolean']['input']>;
  examFormDataInputRowType?: InputMaybe<ExamFormDataInputRowType>;
  id?: InputMaybe<Scalars['String']['input']>;
  inputPlaceholder?: InputMaybe<Scalars['String']['input']>;
  inputValue?: InputMaybe<Scalars['String']['input']>;
  isTextArea?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  maxLabel?: InputMaybe<Scalars['String']['input']>;
  minLabel?: InputMaybe<Scalars['String']['input']>;
  rowTitle?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
}

export enum ExamFormDataInputRowType {
  Checkbox = 'Checkbox',
  DateInput = 'DateInput',
  DegreesButton = 'DegreesButton',
  DegreesNumber = 'DegreesNumber',
  MultiDateInput = 'MultiDateInput',
  MultipleSelectDropdown = 'MultipleSelectDropdown',
  NumberField = 'NumberField',
  OneToTenSplitButton = 'OneToTenSplitButton',
  Percent = 'Percent',
  PercentSlider = 'PercentSlider',
  PosNeg = 'PosNeg',
  RepsNumber = 'RepsNumber',
  SecondsNumber = 'SecondsNumber',
  SingleSelectDropdown = 'SingleSelectDropdown',
  Temperature = 'Temperature',
  TextField = 'TextField',
  YesNo = 'YesNo'
}

export enum ExamFormDataInputType {
  ExamFormDataInput = 'ExamFormDataInput'
}

export interface ExamFormFamilyTagOrder {
  __typename?: 'ExamFormFamilyTagOrder';
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
}

export interface ExamFormFilterInput {
  bodyPositionTags?: InputMaybe<StringFilterInput>;
  bodyRegionTags?: InputMaybe<StringFilterInput>;
  bodySegmentTags?: InputMaybe<StringFilterInput>;
  diagnosisTags?: InputMaybe<StringFilterInput>;
  examTitle?: InputMaybe<StringFilterInput>;
  familyTags?: InputMaybe<StringFilterInput>;
  levelTags?: InputMaybe<StringFilterInput>;
  triageSetTags?: InputMaybe<StringFilterInput>;
}

export interface ExamFormStatus {
  __typename?: 'ExamFormStatus';
  examFormStatusType: ExamFormStatusType;
  timestamp: Scalars['AWSDateTime']['output'];
}

export interface ExamFormStatusInput {
  examFormStatusType: ExamFormStatusType;
  timestamp: Scalars['AWSDateTime']['input'];
}

export enum ExamFormStatusType {
  Completed = 'Completed',
  Deleted = 'Deleted',
  InProgress = 'InProgress',
  Incomplete = 'Incomplete',
  NotStarted = 'NotStarted'
}

export interface ExamFormTableColumnAnswer {
  __typename?: 'ExamFormTableColumnAnswer';
  inputValueBoolean?: Maybe<Scalars['Boolean']['output']>;
  inputValueComment?: Maybe<Scalars['String']['output']>;
  inputValueDegrees?: Maybe<Scalars['Float']['output']>;
  inputValueMultiSelect?: Maybe<Array<Scalars['String']['output']>>;
  inputValueNumber?: Maybe<Scalars['Float']['output']>;
  inputValuePercent?: Maybe<Scalars['Float']['output']>;
  inputValuePosNeg?: Maybe<PosNegEnum>;
  inputValueSeconds?: Maybe<Scalars['Float']['output']>;
  inputValueTemp?: Maybe<Scalars['Float']['output']>;
  inputValueText?: Maybe<Scalars['String']['output']>;
  inputValueYesNo?: Maybe<Scalars['Boolean']['output']>;
}

export interface ExamFormTableColumnAnswerInput {
  inputValueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  inputValueComment?: InputMaybe<Scalars['String']['input']>;
  inputValueDegrees?: InputMaybe<Scalars['Float']['input']>;
  inputValueMultiSelect?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inputValueNumber?: InputMaybe<Scalars['Float']['input']>;
  inputValuePercent?: InputMaybe<Scalars['Float']['input']>;
  inputValuePosNeg?: InputMaybe<PosNegEnum>;
  inputValueSeconds?: InputMaybe<Scalars['Float']['input']>;
  inputValueTemp?: InputMaybe<Scalars['Float']['input']>;
  inputValueText?: InputMaybe<Scalars['String']['input']>;
  inputValueYesNo?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface ExamFormTableRow {
  __typename?: 'ExamFormTableRow';
  addInputText?: Maybe<Scalars['Boolean']['output']>;
  examFormTableRowType: ExamFormTableRowType;
  id: Scalars['String']['output'];
  rowTitle?: Maybe<Scalars['String']['output']>;
}

export interface ExamFormTableRowInput {
  addInputText?: InputMaybe<Scalars['Boolean']['input']>;
  examFormTableRowType?: InputMaybe<ExamFormTableRowType>;
  id?: InputMaybe<Scalars['String']['input']>;
  rowTitle?: InputMaybe<Scalars['String']['input']>;
}

export enum ExamFormTableRowType {
  Checkbox = 'Checkbox',
  DegreesButton = 'DegreesButton',
  DegreesNumber = 'DegreesNumber',
  MultipleSelectDropdown = 'MultipleSelectDropdown',
  NegativePositiveSlider = 'NegativePositiveSlider',
  NumberField = 'NumberField',
  Percent = 'Percent',
  PercentSlider = 'PercentSlider',
  PosNeg = 'PosNeg',
  Radio = 'Radio',
  RepsNumber = 'RepsNumber',
  SecondsNumber = 'SecondsNumber',
  SingleSelectDropdown = 'SingleSelectDropdown',
  TextField = 'TextField',
  Wfl = 'Wfl',
  YesNo = 'YesNo'
}

export enum ExamFormTableType {
  ExamFormRlTable = 'ExamFormRLTable',
  ExamFormRlTableChoice = 'ExamFormRLTableChoice'
}

export interface ExamFormTagFile {
  __typename?: 'ExamFormTagFile';
  color?: Maybe<Scalars['String']['output']>;
  icd10?: Maybe<Scalars['String']['output']>;
  quadrant?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface ExamFormTagMetadata {
  __typename?: 'ExamFormTagMetadata';
  regions: Array<Scalars['String']['output']>;
  value: Scalars['String']['output'];
}

export interface ExamFormTagTypeResult {
  __typename?: 'ExamFormTagTypeResult';
  label: Scalars['String']['output'];
  multipleSelection?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
}

export interface ExamFormTagsResponse {
  __typename?: 'ExamFormTagsResponse';
  items: Array<ExamFormTagFile>;
  metadata?: Maybe<Array<Maybe<ExamFormTagMetadata>>>;
  types: Array<ExamFormTagTypeResult>;
}

export type ExamFormTest = ExamFormTestChoice | ExamFormTestData | ExamFormTestProm | ExamFormTestTable;

export interface ExamFormTestChoice {
  __typename?: 'ExamFormTestChoice';
  comments?: Maybe<Scalars['Boolean']['output']>;
  commentsPlaceholder?: Maybe<Scalars['String']['output']>;
  commentsText?: Maybe<Scalars['String']['output']>;
  conditional?: Maybe<Scalars['Boolean']['output']>;
  conditionalSelected?: Maybe<Scalars['Boolean']['output']>;
  conditionalStyleRendering?: Maybe<ConditionalStyleRendering>;
  examFormChoiceAnswers?: Maybe<Array<Maybe<ExamFormChoiceAnswer>>>;
  examFormChoiceRows?: Maybe<Array<ExamFormChoiceRow>>;
  examFormChoiceType: ExamFormChoiceType;
  isMultipleSelect?: Maybe<Scalars['Boolean']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  testKey?: Maybe<TestKey>;
  testTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
}

export interface ExamFormTestChoiceInput {
  comments?: InputMaybe<Scalars['Boolean']['input']>;
  commentsPlaceholder?: InputMaybe<Scalars['String']['input']>;
  commentsText?: InputMaybe<Scalars['String']['input']>;
  conditional?: InputMaybe<Scalars['Boolean']['input']>;
  conditionalSelected?: InputMaybe<Scalars['Boolean']['input']>;
  conditionalStyleRendering?: InputMaybe<ConditionalStyleRendering>;
  examFormChoiceRows?: InputMaybe<Array<InputMaybe<ExamFormChoiceRowInput>>>;
  examFormChoiceType?: InputMaybe<ExamFormChoiceType>;
  isMultipleSelect?: InputMaybe<Scalars['Boolean']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  testKey?: InputMaybe<TestKey>;
  testTitle?: InputMaybe<Scalars['String']['input']>;
}

export interface ExamFormTestData {
  __typename?: 'ExamFormTestData';
  comments?: Maybe<Scalars['Boolean']['output']>;
  commentsText?: Maybe<Scalars['String']['output']>;
  conditional?: Maybe<Scalars['Boolean']['output']>;
  conditionalSelected?: Maybe<Scalars['Boolean']['output']>;
  conditionalStyleRendering?: Maybe<ConditionalStyleRendering>;
  examFormDataInputColumnAnswers?: Maybe<Array<Maybe<ExamFormDataInputAnswer>>>;
  examFormDataInputRows?: Maybe<Array<ExamFormDataInputRow>>;
  examFormDataInputType: ExamFormDataInputType;
  subTitle?: Maybe<Scalars['String']['output']>;
  testKey?: Maybe<TestKey>;
  testTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
}

export interface ExamFormTestDataInput {
  __typename?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['Boolean']['input']>;
  commentsPlaceholder?: InputMaybe<Scalars['String']['input']>;
  commentsText?: InputMaybe<Scalars['String']['input']>;
  conditional?: InputMaybe<Scalars['Boolean']['input']>;
  conditionalSelected?: InputMaybe<Scalars['Boolean']['input']>;
  conditionalStyleRendering?: InputMaybe<ConditionalStyleRendering>;
  examFormChoiceAnswers?: InputMaybe<Array<InputMaybe<ExamFormChoiceInput>>>;
  examFormChoiceRows?: InputMaybe<Array<InputMaybe<ExamFormChoiceInput>>>;
  examFormChoiceType?: InputMaybe<ExamFormChoiceType>;
  examFormDataInputColumnAnswers?: InputMaybe<Array<InputMaybe<ExamFormDataInputColumnAnswerInput>>>;
  examFormDataInputRows?: InputMaybe<Array<InputMaybe<ExamFormDataInputRowInput>>>;
  examFormDataInputType?: InputMaybe<ExamFormDataInputType>;
  isMultipleSelect?: InputMaybe<Scalars['Boolean']['input']>;
  promBodyRegion?: InputMaybe<Prom>;
  promName?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  redToGreen?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['Int']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  testKey?: InputMaybe<TestKey>;
  testTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
}

export interface ExamFormTestInput {
  __typename?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['Boolean']['input']>;
  commentsPlaceholder?: InputMaybe<Scalars['String']['input']>;
  commentsText?: InputMaybe<Scalars['String']['input']>;
  conditionalStyleRendering?: InputMaybe<ConditionalStyleRendering>;
  examFormChoiceAnswers?: InputMaybe<Array<InputMaybe<ExamFormChoiceInput>>>;
  examFormChoiceRows?: InputMaybe<Array<InputMaybe<ExamFormChoiceInput>>>;
  examFormChoiceType?: InputMaybe<ExamFormChoiceType>;
  examFormDataInputColumnAnswers?: InputMaybe<Array<InputMaybe<ExamFormDataInputColumnAnswerInput>>>;
  examFormDataInputRows?: InputMaybe<Array<InputMaybe<ExamFormDataInputRowInput>>>;
  examFormDataInputType?: InputMaybe<ExamFormDataInputType>;
  examFormTableColumnAnswers?: InputMaybe<Array<InputMaybe<Array<InputMaybe<ExamFormTableColumnAnswerInput>>>>>;
  examFormTableRows?: InputMaybe<Array<InputMaybe<ExamFormTableRowInput>>>;
  examFormTableType?: InputMaybe<ExamFormTableType>;
  isMultipleSelect?: InputMaybe<Scalars['Boolean']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  testTitle?: InputMaybe<Scalars['String']['input']>;
}

export interface ExamFormTestProm {
  __typename?: 'ExamFormTestProm';
  comments?: Maybe<Scalars['Boolean']['output']>;
  commentsText?: Maybe<Scalars['String']['output']>;
  promBodyRegion?: Maybe<Prom>;
  promName?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<Question>>;
  redToGreen?: Maybe<Scalars['Boolean']['output']>;
  startAt?: Maybe<Scalars['Int']['output']>;
  testKey?: Maybe<TestKey>;
  testTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
}

export interface ExamFormTestTable {
  __typename?: 'ExamFormTestTable';
  comments?: Maybe<Scalars['Boolean']['output']>;
  commentsText?: Maybe<Scalars['String']['output']>;
  conditionalStyleRendering?: Maybe<ConditionalStyleRendering>;
  examFormTableColumnAnswers?: Maybe<Array<Maybe<Array<Maybe<ExamFormTableColumnAnswer>>>>>;
  examFormTableRows?: Maybe<Array<ExamFormTableRow>>;
  examFormTableType: ExamFormTableType;
  testKey?: Maybe<TestKey>;
  testTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
}

export interface ExamFormsConnection {
  __typename?: 'ExamFormsConnection';
  items?: Maybe<Array<Maybe<ExamForm>>>;
  limit?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface Exercise {
  __typename?: 'Exercise';
  bodyPositionTags: Array<ExerciseTag>;
  bodyRegionTags: Array<ExerciseTag>;
  diagnosisTags: Array<ExerciseTag>;
  id: Scalars['String']['output'];
  reps: Scalars['Int']['output'];
  repsUnit: RepsUnit;
  sets: Scalars['Int']['output'];
  specialInstructions: Scalars['String']['output'];
  title: Scalars['String']['output'];
  videoPlayed?: Maybe<Scalars['Boolean']['output']>;
}

export interface ExerciseDay {
  __typename?: 'ExerciseDay';
  dayCompletedByPatient?: Maybe<Scalars['Boolean']['output']>;
  daySummary: Scalars['String']['output'];
  dayTitle: Scalars['String']['output'];
  exercises?: Maybe<Array<Maybe<Exercise>>>;
}

export interface ExerciseDayInput {
  dayCompletedByPatient?: InputMaybe<Scalars['Boolean']['input']>;
  daySummary: Scalars['String']['input'];
  dayTitle: Scalars['String']['input'];
  exercises?: InputMaybe<Array<InputMaybe<ExerciseInput>>>;
}

export interface ExerciseInput {
  bodyPositionTags: Array<ExerciseTagInput>;
  bodyRegionTags: Array<ExerciseTagInput>;
  diagnosisTags: Array<ExerciseTagInput>;
  id: Scalars['String']['input'];
  reps: Scalars['Int']['input'];
  repsUnit: RepsUnit;
  sets: Scalars['Int']['input'];
  specialInstructions: Scalars['String']['input'];
  title: Scalars['String']['input'];
  videoPlayed?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface ExerciseTag {
  __typename?: 'ExerciseTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface ExerciseTagInput {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
}

export interface ExtractInsuranceCardInput {
  backImageKey?: InputMaybe<Scalars['String']['input']>;
  frontImageKey: Scalars['String']['input'];
}

export interface ExtractInsuranceCardResponse {
  __typename?: 'ExtractInsuranceCardResponse';
  firstName?: Maybe<Scalars['String']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  status: InsuranceCardExtractionStatus;
}

export interface FallHistoryData {
  __typename?: 'FallHistoryData';
  fallCount?: Maybe<Scalars['String']['output']>;
  hadFall?: Maybe<Scalars['Boolean']['output']>;
}

export interface FallHistorySectionInput {
  fallCount?: InputMaybe<Scalars['String']['input']>;
  hadFall: Scalars['Boolean']['input'];
}

export interface FallRecord {
  __typename?: 'FallRecord';
  approximateFallCount?: Maybe<Scalars['Int']['output']>;
  hadFallenByLosingBalance: Scalars['Boolean']['output'];
  hasVisionIssues?: Maybe<Scalars['Boolean']['output']>;
  useAssistiveDevice?: Maybe<Scalars['Boolean']['output']>;
}

export interface FallRecordInput {
  approximateFallCount?: InputMaybe<Scalars['Int']['input']>;
  hadFallenByLosingBalance: Scalars['Boolean']['input'];
  hasVisionIssues?: InputMaybe<Scalars['Boolean']['input']>;
  useAssistiveDevice?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface FamilyTagOrderInput {
  __typename?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Int']['input'];
}

export interface File {
  __typename?: 'File';
  fileBytesSize: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  uploadedOn: Scalars['AWSDateTime']['output'];
}

export interface FileInput {
  fileBytesSize: Scalars['Int']['input'];
  fileName: Scalars['String']['input'];
  uploadedOn: Scalars['AWSDateTime']['input'];
}

export interface FunctionalLimitation {
  __typename?: 'FunctionalLimitation';
  goalToAchieve: Scalars['String']['output'];
  limitedActivity: Scalars['String']['output'];
}

export enum Gender {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other',
  PreferNotToSay = 'PreferNotToSay'
}

export interface GeneralResponse {
  __typename?: 'GeneralResponse';
  errorMsg?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
}

export interface GenerateClinicalReportsInput {
  appointmentReportInput?: InputMaybe<AppointmentReportInput>;
  dischargeReportInput?: InputMaybe<DischargeReportInput>;
  reportType: ClinicalReportType;
}

export interface GetChatFilesDownloadUrlsInput {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  fileKey?: InputMaybe<Scalars['String']['input']>;
  messageTimeStamp?: InputMaybe<Scalars['String']['input']>;
}

export interface GetProviderCalendarFilter {
  dateTimeRange: DateTimeRangeInput;
  providerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<Scalars['String']['input']>;
}

export interface GetProvidersFilter {
  and?: InputMaybe<Array<InputMaybe<GetProvidersFilterItemInput>>>;
  or?: InputMaybe<Array<InputMaybe<GetProvidersFilterItemInput>>>;
}

export interface GetProvidersFilterItemInput {
  licenseState?: InputMaybe<StringFilterInput>;
  userGroup?: InputMaybe<StringFilterInput>;
}

export interface GetProvidersSlotsFilter {
  appointmentType?: InputMaybe<Scalars['String']['input']>;
  dateTimeRange: DateTimeRangeInput;
  includeNewEvals?: InputMaybe<Scalars['Boolean']['input']>;
  providerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<Scalars['String']['input']>;
}

export interface GoalInput {
  completed: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
}

export interface HabitsData {
  __typename?: 'HabitsData';
  activityLevel?: Maybe<Scalars['String']['output']>;
  alcohol?: Maybe<Scalars['Boolean']['output']>;
  alcoholFrequency?: Maybe<Scalars['String']['output']>;
  otherSubstance?: Maybe<Scalars['Boolean']['output']>;
  otherSubstanceFrequency?: Maybe<Scalars['String']['output']>;
  otherSubstanceList?: Maybe<Scalars['String']['output']>;
  tobacco?: Maybe<Scalars['Boolean']['output']>;
  tobaccoFrequency?: Maybe<Scalars['String']['output']>;
}

export interface HabitsSectionInput {
  activityLevel?: InputMaybe<Scalars['String']['input']>;
  alcohol: Scalars['Boolean']['input'];
  alcoholFrequency?: InputMaybe<Scalars['String']['input']>;
  otherSubstance: Scalars['Boolean']['input'];
  otherSubstanceFrequency?: InputMaybe<Scalars['String']['input']>;
  otherSubstanceList?: InputMaybe<Scalars['String']['input']>;
  tobacco: Scalars['Boolean']['input'];
  tobaccoFrequency?: InputMaybe<Scalars['String']['input']>;
}

export interface HealthBackgroundData {
  __typename?: 'HealthBackgroundData';
  allergies?: Maybe<Array<AllergenOption>>;
  cancer?: Maybe<CancerData>;
  conditionAnswers?: Maybe<Array<HealthHistoryConditionAnswerData>>;
  conditions?: Maybe<Array<Scalars['String']['output']>>;
  fallHistory?: Maybe<FallHistoryData>;
  habits?: Maybe<HabitsData>;
  heightFeet?: Maybe<Scalars['Int']['output']>;
  heightInches?: Maybe<Scalars['Int']['output']>;
  medications?: Maybe<Array<MedicationOption>>;
  sexAtBirth?: Maybe<Scalars['String']['output']>;
  surgicalHistory?: Maybe<SurgicalHistoryData>;
  weightLb?: Maybe<Scalars['Int']['output']>;
}

export interface HealthBackgroundSectionInput {
  allergies?: InputMaybe<Array<AllergyInput>>;
  cancer?: InputMaybe<CancerSectionInput>;
  conditionAnswers?: InputMaybe<Array<HealthHistoryConditionAnswerInput>>;
  conditions?: InputMaybe<Array<Scalars['String']['input']>>;
  fallHistory?: InputMaybe<FallHistorySectionInput>;
  habits?: InputMaybe<HabitsSectionInput>;
  heightFeet: Scalars['Int']['input'];
  heightInches: Scalars['Int']['input'];
  medications?: InputMaybe<Array<MedicationInput>>;
  sexAtBirth: Scalars['String']['input'];
  surgicalHistory?: InputMaybe<SurgicalHistorySectionInput>;
  weightLb: Scalars['Int']['input'];
}

export interface HealthHistory {
  __typename?: 'HealthHistory';
  alcoholUsedFrequency?: Maybe<Scalars['String']['output']>;
  allergyListStr?: Maybe<Scalars['String']['output']>;
  cancerRecordList: Array<MedicalRecordItem>;
  depressionRecord: DepressionRecord;
  dexaScanDate?: Maybe<Scalars['AWSDate']['output']>;
  dexaScanResult?: Maybe<Scalars['String']['output']>;
  existingMedicalConditions: Array<Scalars['String']['output']>;
  fallRecord: FallRecord;
  hadDexaScan?: Maybe<Scalars['String']['output']>;
  otcMedicationListStr?: Maybe<Scalars['String']['output']>;
  otherSubstanceUsed?: Maybe<Scalars['String']['output']>;
  prescriptedMedicationListStr?: Maybe<Scalars['String']['output']>;
  supplementListStr?: Maybe<Scalars['String']['output']>;
  surgeryRecordList: Array<MedicalRecordItem>;
  tobacooUsedFrequency?: Maybe<Scalars['String']['output']>;
}

export enum HealthHistoryConditionAnswer {
  No = 'NO',
  Yes = 'YES'
}

export interface HealthHistoryConditionAnswerData {
  __typename?: 'HealthHistoryConditionAnswerData';
  answer: HealthHistoryConditionAnswer;
  key: Scalars['String']['output'];
}

export interface HealthHistoryConditionAnswerInput {
  answer: HealthHistoryConditionAnswer;
  key: Scalars['String']['input'];
}

export interface HealthHistoryInput {
  alcoholUsedFrequency?: InputMaybe<Scalars['String']['input']>;
  allergyListStr?: InputMaybe<Scalars['String']['input']>;
  cancerRecordList: Array<MedicalRecordItemInput>;
  depressionRecord: DepressionRecordInput;
  dexaScanDate?: InputMaybe<Scalars['AWSDate']['input']>;
  dexaScanResult?: InputMaybe<Scalars['String']['input']>;
  existingMedicalConditions: Array<Scalars['String']['input']>;
  fallRecord: FallRecordInput;
  hadDexaScan?: InputMaybe<Scalars['String']['input']>;
  otcMedicationListStr?: InputMaybe<Scalars['String']['input']>;
  otherSubstanceUsed?: InputMaybe<Scalars['String']['input']>;
  prescriptedMedicationListStr?: InputMaybe<Scalars['String']['input']>;
  supplementListStr?: InputMaybe<Scalars['String']['input']>;
  surgeryRecordList: Array<MedicalRecordItemInput>;
  tobacooUsedFrequency?: InputMaybe<Scalars['String']['input']>;
}

export interface Height {
  __typename?: 'Height';
  feet: Scalars['Int']['output'];
  inches: Scalars['Int']['output'];
}

export interface HeightInput {
  feet: Scalars['Int']['input'];
  inches: Scalars['Int']['input'];
}

export interface HomeAddress {
  __typename?: 'HomeAddress';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  optionalAddress?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
}

export interface HomeAddressData {
  __typename?: 'HomeAddressData';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  optionalAddress?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
}

export interface HomeAddressInput {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  optionalAddress?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
}

export interface HomeAddressSectionInput {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  optionalAddress?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
}

export interface HubspotContactPrefill {
  __typename?: 'HubspotContactPrefill';
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  existingPatient?: Maybe<HubspotExistingPatient>;
  firstName?: Maybe<Scalars['String']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  hubspotContactId: Scalars['ID']['output'];
  insuranceName?: Maybe<Scalars['String']['output']>;
  intakeSource?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
}

export interface HubspotExistingPatient {
  __typename?: 'HubspotExistingPatient';
  canvasPatientId: Scalars['ID']['output'];
  matchedBy: Scalars['String']['output'];
}

export interface InAppNotification {
  __typename?: 'InAppNotification';
  message: Scalars['String']['output'];
  notificationId: Scalars['ID']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  status: InAppNotificationStatus;
  timeSent: Scalars['AWSDateTime']['output'];
  title: Scalars['String']['output'];
  type: InAppNotificationType;
  updatedOn?: Maybe<Scalars['AWSDateTime']['output']>;
  userId: Scalars['ID']['output'];
}

export enum InAppNotificationStatus {
  Read = 'Read',
  Sent = 'Sent'
}

export enum InAppNotificationType {
  AppointmentReminder = 'AppointmentReminder',
  AppointmentScheduled = 'AppointmentScheduled',
  CarePlanAvailable = 'CarePlanAvailable',
  Unknown = 'Unknown'
}

export interface Incident {
  affectedBodyRegion?: Maybe<AffectedBodyRegion>;
  files?: Maybe<Array<Maybe<File>>>;
  occurredOn?: Maybe<Scalars['AWSDate']['output']>;
}

export type IncidentTypes = Injury | Surgery;

export interface Injury extends Incident {
  __typename?: 'Injury';
  affectedBodyRegion: AffectedBodyRegion;
  files: Array<File>;
  functionalLimitation: FunctionalLimitation;
  occurredOn?: Maybe<Scalars['AWSDate']['output']>;
  onsetWindow?: Maybe<Scalars['String']['output']>;
}

export interface InsuranceCard {
  __typename?: 'InsuranceCard';
  groupNumber?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  payerId?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
}

export enum InsuranceCardExtractionStatus {
  Failed = 'FAILED',
  NoText = 'NO_TEXT',
  Partial = 'PARTIAL',
  Success = 'SUCCESS'
}

export interface InsuranceCardInput {
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  payerId?: InputMaybe<Scalars['String']['input']>;
  payerName?: InputMaybe<Scalars['String']['input']>;
}

export interface InsuranceData {
  __typename?: 'InsuranceData';
  groupNumber?: Maybe<Scalars['String']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  payerId?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  subscriberDob?: Maybe<Scalars['String']['output']>;
  subscriberFirstName?: Maybe<Scalars['String']['output']>;
  subscriberId?: Maybe<Scalars['String']['output']>;
  subscriberLastName?: Maybe<Scalars['String']['output']>;
}

export interface InsuranceInfo {
  __typename?: 'InsuranceInfo';
  insurances: Array<InsuranceItem>;
}

export interface InsuranceInfoInput {
  insurances: Array<InsuranceItemInput>;
}

export interface InsuranceItem {
  __typename?: 'InsuranceItem';
  groupNumber?: Maybe<Scalars['String']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  payerId?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  subscriberId: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface InsuranceItemInput {
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  isPrimary: Scalars['Boolean']['input'];
  payerId?: InputMaybe<Scalars['String']['input']>;
  payerName?: InputMaybe<Scalars['String']['input']>;
  subscriberId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
}

export interface InsuranceSectionInput {
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  payerId: Scalars['String']['input'];
  payerName?: InputMaybe<Scalars['String']['input']>;
  relationship: Scalars['String']['input'];
  subscriberDob?: InputMaybe<Scalars['String']['input']>;
  subscriberFirstName?: InputMaybe<Scalars['String']['input']>;
  subscriberId: Scalars['String']['input'];
  subscriberLastName?: InputMaybe<Scalars['String']['input']>;
}

export enum IntakeSource {
  Amazon = 'Amazon',
  Carelon = 'Carelon',
  Hss = 'HSS',
  SelfSignUp = 'SelfSignUp'
}

export interface KemtaiActivity {
  __typename?: 'KemtaiActivity';
  assignedAt?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  completionsLastWeek: Scalars['Int']['output'];
  contentId: Scalars['String']['output'];
  contentType: KemtaiContentType;
  durationSeconds: Scalars['Int']['output'];
  equipment: Array<Scalars['String']['output']>;
  exerciseCount: Scalars['Int']['output'];
  frequency?: Maybe<KemtaiFrequency>;
  id: Scalars['String']['output'];
  seenAt?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: KemtaiActivityStatus;
  tags: Array<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  timesPerformed: Scalars['Int']['output'];
  timesPerformedToday: Scalars['Int']['output'];
  timesPrescribed: Scalars['Int']['output'];
  timesPrescribedToday: Scalars['Int']['output'];
  title: Scalars['String']['output'];
}

export interface KemtaiActivityResult {
  __typename?: 'KemtaiActivityResult';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
}

export enum KemtaiActivityStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Terminated = 'TERMINATED'
}

export enum KemtaiContentType {
  EducationalContent = 'EDUCATIONAL_CONTENT',
  ExerciseProtocol = 'EXERCISE_PROTOCOL',
  Form = 'FORM',
  RomAssessment = 'ROM_ASSESSMENT',
  Task = 'TASK'
}

export interface KemtaiEmbedSession {
  __typename?: 'KemtaiEmbedSession';
  token?: Maybe<Scalars['String']['output']>;
}

export interface KemtaiFrequency {
  __typename?: 'KemtaiFrequency';
  daysOfWeek: Array<Scalars['String']['output']>;
  intervalDays?: Maybe<Scalars['Int']['output']>;
  isOnce: Scalars['Boolean']['output'];
  timesPerDay?: Maybe<Scalars['Int']['output']>;
  timesPerWeek?: Maybe<Scalars['Int']['output']>;
}

export interface KemtaiPatient {
  __typename?: 'KemtaiPatient';
  id?: Maybe<Scalars['String']['output']>;
}

export interface ListCmsVideosResponse {
  __typename?: 'ListCMSVideosResponse';
  items: Array<CmsVideo>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface ListClaimFilter {
  and?: InputMaybe<Array<ListClaimFilter>>;
  or?: InputMaybe<Array<ListClaimFilter>>;
  status?: InputMaybe<StringFilterInput>;
}

export interface ListClaimResponse {
  __typename?: 'ListClaimResponse';
  items: Array<Claim>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface ListInAppNotificationsResponse {
  __typename?: 'ListInAppNotificationsResponse';
  items: Array<InAppNotification>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface ListReferralHistoryFilter {
  and?: InputMaybe<Array<ListReferralHistoryFilter>>;
  firstName?: InputMaybe<StringFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  onboardingStatus?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<ListReferralHistoryFilter>>;
  status?: InputMaybe<StringFilterInput>;
  triageAppointmentId?: InputMaybe<StringFilterInput>;
}

export interface ListReferralHistoryResponse {
  __typename?: 'ListReferralHistoryResponse';
  items: Array<ReferralHistory>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface ManagePromData {
  __typename?: 'ManagePromData';
  episodeOfCareId: Scalars['String']['output'];
  promItems: Array<PromItem>;
}

export interface ManagePromError {
  __typename?: 'ManagePromError';
  details?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
}

export enum ManagePromEvent {
  CreateFollowUpPromItems = 'CreateFollowUpPromItems',
  RequestProm = 'RequestProm',
  UpdateCanvasPromResponse = 'UpdateCanvasPromResponse',
  UpdatePromItem = 'UpdatePromItem',
  UpdatePromRemindedAt = 'UpdatePromRemindedAt',
  UpdatePromRequestAt = 'UpdatePromRequestAt',
  UpdatePromResponse = 'UpdatePromResponse'
}

export interface ManagePromInput {
  createFollowUpPromsInput?: InputMaybe<CreateFollowUpPromsInput>;
  episodeOfCareId: Scalars['String']['input'];
  requestPromInput?: InputMaybe<RequestPromInput>;
  updateCanvasPromResponseInput?: InputMaybe<UpdateCanvasPromResponseInput>;
  updatePromItemInput?: InputMaybe<UpdatePromItemInput>;
  updatePromResponseInput?: InputMaybe<UpdatePromResponseInput>;
}

export interface ManagePromResponse {
  __typename?: 'ManagePromResponse';
  data?: Maybe<ManagePromData>;
  error?: Maybe<ManagePromError>;
  success: Scalars['Boolean']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
}

export enum ManagePromV2Event {
  UpdateCanvasPromResponse = 'UpdateCanvasPromResponse'
}

export interface ManagePromV2Input {
  updateCanvasPromResponseInput?: InputMaybe<UpdateCanvasPromResponseInput>;
}

export interface ManagePromV2Response {
  __typename?: 'ManagePromV2Response';
  error?: Maybe<ManagePromError>;
  success: Scalars['Boolean']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
}

export interface MedicalRecordItem {
  __typename?: 'MedicalRecordItem';
  date: Scalars['AWSDate']['output'];
  value: Scalars['String']['output'];
}

export interface MedicalRecordItemInput {
  date: Scalars['AWSDate']['input'];
  value: Scalars['String']['input'];
}

export interface MedicationInput {
  display: Scalars['String']['input'];
  fdbCode: Scalars['String']['input'];
  rxnormCode?: InputMaybe<Scalars['String']['input']>;
  sig?: InputMaybe<Scalars['String']['input']>;
}

export interface MedicationOption {
  __typename?: 'MedicationOption';
  display: Scalars['String']['output'];
  fdbCode: Scalars['String']['output'];
  rxnormCode?: Maybe<Scalars['String']['output']>;
}

export interface MskRedFlag {
  __typename?: 'MskRedFlag';
  redFlagResponses: Array<RedFlagResponse>;
}

export interface MskRedFlagInput {
  redFlagResponses?: InputMaybe<Array<RedFlagResponseInput>>;
}

export interface Mutation {
  __typename?: 'Mutation';
  addBill?: Maybe<Bill>;
  addChatMessage?: Maybe<ChatMessage>;
  addClaim?: Maybe<Claim>;
  addConversation?: Maybe<Conversation>;
  addExamForm?: Maybe<ExamForm>;
  addInAppNotification: InAppNotification;
  addNonEligibleUser?: Maybe<NonEligibleUser>;
  addProviderUser?: Maybe<ProviderUser>;
  addSoap?: Maybe<Soap>;
  cancelAppointmentByCanvasId: ScheduledCanvasAppointmentResponse;
  cancelCanvasPhoneAppointment: CanvasSchedulerResponse;
  cancelCanvasTriageAppointment: CanvasSchedulerResponse;
  completeOnboardingV2: GeneralResponse;
  concludeVisit: CanvasSchedulerResponse;
  createAccommodationForm?: Maybe<AccommodationForm>;
  createAdminReferral: CreateAdminReferralResponse;
  createCanvasFollowUpAppointment: CanvasSchedulerResponse;
  createCanvasPhoneAppointment: CanvasSchedulerResponse;
  createCanvasTriageAppointment: CanvasSchedulerResponse;
  createKemtaiPatient: KemtaiPatient;
  deleteAccommodationForm?: Maybe<AccommodationForm>;
  deleteExamForm?: Maybe<ExamForm>;
  deleteExamFormWithFamilyTags?: Maybe<ExamForm>;
  deleteSoap?: Maybe<Soap>;
  extractInsuranceCard?: Maybe<ExtractInsuranceCardResponse>;
  invokeNotificationsEngine?: Maybe<Scalars['Boolean']['output']>;
  manageProm?: Maybe<ManagePromResponse>;
  managePromV2: ManagePromV2Response;
  recordConversationParticipant?: Maybe<Conversation>;
  recordConversationSeen?: Maybe<Conversation>;
  reorderFormsInFamilyTags?: Maybe<Array<Maybe<ExamForm>>>;
  requestDocumentCosign?: Maybe<Scalars['String']['output']>;
  requestMagicLink?: Maybe<Scalars['Boolean']['output']>;
  rescheduleAppointmentByCanvasId: ScheduledCanvasAppointmentResponse;
  rescheduleCanvasAppointment: CanvasSchedulerResponse;
  rescheduleCanvasPhoneAppointment: CanvasSchedulerResponse;
  scheduleCanvasAppointment: ScheduledCanvasAppointmentResponse;
  seedConversationParticipants?: Maybe<Conversation>;
  seedConversationSeen?: Maybe<Conversation>;
  setSelfPayPayer: GeneralResponse;
  signSoapTransaction?: Maybe<Soap>;
  storeOnboardingSection: GeneralResponse;
  toggleMessagePin?: Maybe<ChatMessage>;
  updateAccommodationForm?: Maybe<AccommodationForm>;
  updateAccommodationFormStatus?: Maybe<AccommodationForm>;
  updateAppointmentCallStatus?: Maybe<AppointmentCallStatus>;
  updateBill?: Maybe<Bill>;
  updateCanvasAppointmentStatus: CanvasSchedulerResponse;
  updateCanvasEpisodeOfCare: GeneralResponse;
  updateChatMessage?: Maybe<ChatMessage>;
  updateClaim?: Maybe<Claim>;
  updateClientUser?: Maybe<ClientUser>;
  updateConversation?: Maybe<Conversation>;
  updateExamForm?: Maybe<ExamForm>;
  updateInAppNotificationsTransaction?: Maybe<Array<InAppNotification>>;
  updateProviderUser?: Maybe<ProviderUser>;
  updateReferralDocumentDetails: GeneralResponse;
  updateSoap?: Maybe<Soap>;
  upsertExamForm?: Maybe<ExamForm>;
  verifyInsurance?: Maybe<VerifyInsuranceResponse>;
}


export interface MutationAddBillArgs {
  input: AddBillInput;
}


export interface MutationAddChatMessageArgs {
  input: AddChatMessageInput;
}


export interface MutationAddClaimArgs {
  input: AddClaimInput;
}


export interface MutationAddConversationArgs {
  input: AddConversationInput;
}


export interface MutationAddExamFormArgs {
  input: AddExamFormInput;
}


export interface MutationAddInAppNotificationArgs {
  input: AddInAppNotificationInput;
}


export interface MutationAddNonEligibleUserArgs {
  input: AddNonEligibleUserInput;
}


export interface MutationAddProviderUserArgs {
  input: AddProviderInput;
}


export interface MutationAddSoapArgs {
  input: SoapInput;
}


export interface MutationCancelAppointmentByCanvasIdArgs {
  input: CancelAppointmentByCanvasIdInput;
}


export interface MutationCancelCanvasPhoneAppointmentArgs {
  input: CancelCanvasPhoneAppointmentInput;
}


export interface MutationCancelCanvasTriageAppointmentArgs {
  input: CancelCanvasTriageAppointmentInput;
}


export interface MutationCompleteOnboardingV2Args {
  input: CompleteOnboardingV2Input;
}


export interface MutationConcludeVisitArgs {
  input: ConcludeVisitInput;
}


export interface MutationCreateAccommodationFormArgs {
  input: CreateAccommodationFormInput;
}


export interface MutationCreateAdminReferralArgs {
  input: CreateAdminReferralInput;
}


export interface MutationCreateCanvasFollowUpAppointmentArgs {
  input: CreateCanvasFollowUpAppointmentInput;
}


export interface MutationCreateCanvasPhoneAppointmentArgs {
  input: CreateCanvasPhoneAppointmentInput;
}


export interface MutationCreateCanvasTriageAppointmentArgs {
  input: CreateCanvasTriageAppointmentInput;
}


export interface MutationCreateKemtaiPatientArgs {
  patientId: Scalars['ID']['input'];
}


export interface MutationDeleteAccommodationFormArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteExamFormArgs {
  examFormId: Scalars['ID']['input'];
}


export interface MutationDeleteExamFormWithFamilyTagsArgs {
  examFormId: Scalars['ID']['input'];
}


export interface MutationDeleteSoapArgs {
  appointmentDate: Scalars['AWSDateTime']['input'];
  ptId: Scalars['ID']['input'];
}


export interface MutationExtractInsuranceCardArgs {
  input: ExtractInsuranceCardInput;
}


export interface MutationInvokeNotificationsEngineArgs {
  input: SendNotificationInput;
}


export interface MutationManagePromArgs {
  event: ManagePromEvent;
  input: ManagePromInput;
}


export interface MutationManagePromV2Args {
  event: ManagePromV2Event;
  input: ManagePromV2Input;
}


export interface MutationRecordConversationParticipantArgs {
  canvasStaffId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  didSend?: InputMaybe<Scalars['Boolean']['input']>;
  displayName: Scalars['String']['input'];
  recordedAt: Scalars['AWSDateTime']['input'];
}


export interface MutationRecordConversationSeenArgs {
  canvasStaffId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  seenAt: Scalars['AWSDateTime']['input'];
}


export interface MutationReorderFormsInFamilyTagsArgs {
  input: ReorderFormsInFamilyTagsInput;
}


export interface MutationRequestDocumentCosignArgs {
  appointmentDateTime?: InputMaybe<Scalars['String']['input']>;
  episodeOfCareId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  reportType: Scalars['String']['input'];
}


export interface MutationRequestMagicLinkArgs {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  purpose?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationRescheduleAppointmentByCanvasIdArgs {
  input: RescheduleAppointmentByCanvasIdInput;
}


export interface MutationRescheduleCanvasAppointmentArgs {
  input: RescheduleCanvasAppointmentInput;
}


export interface MutationRescheduleCanvasPhoneAppointmentArgs {
  input: RescheduleCanvasPhoneAppointmentInput;
}


export interface MutationScheduleCanvasAppointmentArgs {
  input: ScheduleCanvasAppointmentInput;
}


export interface MutationSeedConversationParticipantsArgs {
  canvasStaffId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  didSend?: InputMaybe<Scalars['Boolean']['input']>;
  displayName: Scalars['String']['input'];
  recordedAt: Scalars['AWSDateTime']['input'];
}


export interface MutationSeedConversationSeenArgs {
  canvasStaffId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  seenAt: Scalars['AWSDateTime']['input'];
}


export interface MutationSignSoapTransactionArgs {
  input: SignSoapTransactionInput;
}


export interface MutationStoreOnboardingSectionArgs {
  input: StoreOnboardingSectionInput;
}


export interface MutationToggleMessagePinArgs {
  conversationId: Scalars['ID']['input'];
  messageTimeStamp?: InputMaybe<Scalars['AWSDateTime']['input']>;
}


export interface MutationUpdateAccommodationFormArgs {
  input: UpdateAccommodationFormInput;
}


export interface MutationUpdateAccommodationFormStatusArgs {
  id: Scalars['ID']['input'];
  status: AccommodationFormStatus;
}


export interface MutationUpdateAppointmentCallStatusArgs {
  input: UpdateAppointmentCallStatusInput;
}


export interface MutationUpdateBillArgs {
  input: UpdateBillInput;
}


export interface MutationUpdateCanvasAppointmentStatusArgs {
  input: UpdateCanvasAppointmentStatusInput;
}


export interface MutationUpdateCanvasEpisodeOfCareArgs {
  input: UpdateCanvasEpisodeOfCareInput;
}


export interface MutationUpdateChatMessageArgs {
  input: UpdateChatMessageInput;
}


export interface MutationUpdateClaimArgs {
  input: UpdateClaimInput;
}


export interface MutationUpdateClientUserArgs {
  input: UpdateClientUserInput;
}


export interface MutationUpdateConversationArgs {
  input: UpdateConversationInput;
}


export interface MutationUpdateExamFormArgs {
  input: UpdateExamFormInput;
}


export interface MutationUpdateInAppNotificationsTransactionArgs {
  input: UpdateInAppNotificationsTransactionInput;
}


export interface MutationUpdateProviderUserArgs {
  input: UpdateProviderUserInput;
}


export interface MutationUpdateReferralDocumentDetailsArgs {
  input: UpdateReferralDocumentDetailsInput;
}


export interface MutationUpdateSoapArgs {
  input: SoapInput;
}


export interface MutationUpsertExamFormArgs {
  input: UpsertExamFormInput;
}


export interface MutationVerifyInsuranceArgs {
  input: VerifyInsuranceInput;
}

export interface NewAssessmentEocInput {
  appointmentState: Scalars['String']['input'];
  bodyRegion: Scalars['String']['input'];
  eocId: Scalars['ID']['input'];
}

export interface NewChatMessageReminderContext {
  __typename?: 'NewChatMessageReminderContext';
  conversationId: Scalars['ID']['output'];
}

export interface NonEligibleUser {
  __typename?: 'NonEligibleUser';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email: Scalars['ID']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  howDidYouHearFromUs?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  submittedAt: Scalars['AWSDateTime']['output'];
}

export enum NotificationChannel {
  Email = 'Email',
  InApp = 'InApp',
  Push = 'Push',
  Text = 'Text'
}

export type NotificationInput = NewChatMessageReminderContext | PatientPathwayFlagContext;

export interface NotificationPreference {
  __typename?: 'NotificationPreference';
  enabled: Scalars['Boolean']['output'];
  enabledOn?: Maybe<Scalars['AWSDateTime']['output']>;
  notificationChannel: NotificationChannel;
}

export interface NotificationPreferenceInput {
  enabled: Scalars['Boolean']['input'];
  enabledOn?: InputMaybe<Scalars['AWSDateTime']['input']>;
  notificationChannel: NotificationChannel;
}

export interface NotificationRule {
  __typename?: 'NotificationRule';
  appMessageBody: Scalars['String']['output'];
  appMessageTitle: Scalars['String']['output'];
  channel: Array<NotificationChannel>;
  emailMessage: Scalars['String']['output'];
  emailSubject: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  ruleKey: NotificationRuleKey;
  ruleType: NotificationRuleType;
  textMessage: Scalars['String']['output'];
  userGroup: UserGroup;
}

export interface NotificationRuleInput {
  channel: Array<NotificationChannel>;
  enabled: Scalars['Boolean']['input'];
  ruleKey: NotificationRuleKey;
  ruleType: NotificationRuleType;
  textMessage: Scalars['String']['input'];
  userGroup: UserGroup;
}

export enum NotificationRuleKey {
  NewChatMessageReminder = 'NewChatMessageReminder',
  PatientConsents = 'PatientConsents',
  PatientPathwayFlag = 'PatientPathwayFlag',
  PromRenewalReminder = 'PromRenewalReminder'
}

export enum NotificationRuleType {
  Direct = 'Direct',
  Indirect = 'Indirect',
  Schedule = 'Schedule'
}

export interface OnboardingAppointmentData {
  __typename?: 'OnboardingAppointmentData';
  appointmentDateTime?: Maybe<Scalars['AWSDateTime']['output']>;
  appointmentId?: Maybe<Scalars['String']['output']>;
  appointmentState?: Maybe<Scalars['String']['output']>;
  appointmentStatus?: Maybe<Scalars['String']['output']>;
  canvasAppointmentId?: Maybe<Scalars['String']['output']>;
  canvasProviderId?: Maybe<Scalars['String']['output']>;
  noteType?: Maybe<Scalars['String']['output']>;
  ptId?: Maybe<Scalars['String']['output']>;
  variant: AppointmentVariant;
}

export enum OnboardingSection {
  Appointments = 'APPOINTMENTS',
  ConditionDetails = 'CONDITION_DETAILS',
  Consents = 'CONSENTS',
  EmergencyContact = 'EMERGENCY_CONTACT',
  HealthBackground = 'HEALTH_BACKGROUND',
  HomeAddress = 'HOME_ADDRESS',
  Insurance = 'INSURANCE',
  WellBeing = 'WELL_BEING'
}

export interface OnboardingSectionData {
  __typename?: 'OnboardingSectionData';
  appointments?: Maybe<Array<OnboardingAppointmentData>>;
  conditionDetails?: Maybe<ConditionDetailsData>;
  consents?: Maybe<ConsentsData>;
  emergencyContact?: Maybe<EmergencyContactData>;
  healthBackground?: Maybe<HealthBackgroundData>;
  homeAddress?: Maybe<HomeAddressData>;
  insurance?: Maybe<InsuranceData>;
  wellBeing?: Maybe<WellBeingData>;
}

export enum OnboardingStatus {
  AccountCreated = 'ACCOUNT_CREATED',
  AccountVerified = 'ACCOUNT_VERIFIED',
  Initiated = 'INITIATED',
  OnboardingAcknowledged = 'ONBOARDING_ACKNOWLEDGED',
  OnboardingAppointmentDateConfirmed = 'ONBOARDING_APPOINTMENT_DATE_CONFIRMED',
  OnboardingCompleted = 'ONBOARDING_COMPLETED',
  OnboardingConditionsDetails = 'ONBOARDING_CONDITIONS_DETAILS',
  OnboardingHealthHistory = 'ONBOARDING_HEALTH_HISTORY',
  OnboardingIntro = 'ONBOARDING_INTRO',
  OnboardingPatientInfo = 'ONBOARDING_PATIENT_INFO',
  OnboardingPaymentInsurance = 'ONBOARDING_PAYMENT_INSURANCE',
  OnboardingRedFlags = 'ONBOARDING_RED_FLAGS',
  ReferralDocumentReceived = 'REFERRAL_DOCUMENT_RECEIVED'
}

export interface OnboardingSurgeryData {
  __typename?: 'OnboardingSurgeryData';
  month?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
}

export interface OnboardingSurgeryInput {
  month?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  year?: InputMaybe<Scalars['String']['input']>;
}

export interface PartnershipDetails {
  __typename?: 'PartnershipDetails';
  coverageStatus: CoverageStatus;
  partnerName: Scalars['String']['output'];
}

export interface PatientCarePlan {
  __typename?: 'PatientCarePlan';
  carePlanExercises?: Maybe<CarePlanExercises>;
  carePlanInformation?: Maybe<CarePlanInformation>;
  carePlanSent?: Maybe<Scalars['AWSDateTime']['output']>;
}

export interface PatientCarePlanInput {
  carePlanExercises?: InputMaybe<CarePlanExercisesInput>;
  carePlanInformation?: InputMaybe<CarePlanInformationInput>;
  carePlanSent?: InputMaybe<Scalars['AWSDateTime']['input']>;
}

export interface PatientCondition {
  __typename?: 'PatientCondition';
  category: Scalars['String']['output'];
  clinicalStatus: ConditionClinicalStatus;
  codes: Array<PatientConditionCode>;
  id: Scalars['ID']['output'];
  recordedDate?: Maybe<Scalars['AWSDateTime']['output']>;
}

export interface PatientConditionCode {
  __typename?: 'PatientConditionCode';
  code: Scalars['String']['output'];
  display: Scalars['String']['output'];
  system?: Maybe<Scalars['String']['output']>;
}

export interface PatientDetails {
  __typename?: 'PatientDetails';
  emergencyContact: EmergencyContact;
  /** @deprecated Use sex instead */
  gender?: Maybe<Scalars['String']['output']>;
  height: Height;
  homeAddress: HomeAddress;
  nickname?: Maybe<Scalars['String']['output']>;
  occupation: Scalars['String']['output'];
  /** @deprecated Use sex instead */
  pronouns?: Maybe<Scalars['String']['output']>;
  sex: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
}

export interface PatientDetailsInput {
  emergencyContact: EmergencyContactInput;
  /** @deprecated Use sex instead */
  gender?: InputMaybe<Scalars['String']['input']>;
  height: HeightInput;
  homeAddress: HomeAddressInput;
  nickname?: InputMaybe<Scalars['String']['input']>;
  occupation: Scalars['String']['input'];
  /** @deprecated Use sex instead */
  pronouns?: InputMaybe<Scalars['String']['input']>;
  sex: Scalars['String']['input'];
  weight: Scalars['Int']['input'];
}

export interface PatientEligibility {
  __typename?: 'PatientEligibility';
  bypassEligibilityCheck?: Maybe<Scalars['Boolean']['output']>;
  employerOrWorkplace?: Maybe<EmployerOrWorkplace>;
  referralSource: ReferralSource;
}

export interface PatientEligibilityInput {
  bypassEligibilityCheck?: InputMaybe<Scalars['Boolean']['input']>;
  employerOrWorkplace?: InputMaybe<EmployerOrWorkplace>;
  referralSource: ReferralSource;
}

export interface PatientJourneyCandidate {
  __typename?: 'PatientJourneyCandidate';
  detail: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  source: PatientJourneySource;
}

export enum PatientJourneyConfidence {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum PatientJourneyEmailSource {
  Adopted = 'ADOPTED',
  Ambiguous = 'AMBIGUOUS',
  None = 'NONE',
  Pasted = 'PASTED'
}

export interface PatientJourneyEvent {
  __typename?: 'PatientJourneyEvent';
  at: Scalars['String']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  source: PatientJourneySource;
  summaryKind?: Maybe<PatientJourneySummaryKind>;
  summaryRef?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  zone?: Maybe<Scalars['String']['output']>;
}

export interface PatientJourneyEventInput {
  at: Scalars['String']['input'];
  detail?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  source: PatientJourneySource;
  summaryKind?: InputMaybe<PatientJourneySummaryKind>;
  summaryRef?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  zone?: InputMaybe<Scalars['String']['input']>;
}

export interface PatientJourneyFact {
  __typename?: 'PatientJourneyFact';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  source: PatientJourneySource;
  value?: Maybe<Scalars['String']['output']>;
}

export interface PatientJourneyFactInput {
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  source: PatientJourneySource;
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface PatientJourneyFacts {
  __typename?: 'PatientJourneyFacts';
  facts: Array<PatientJourneyFact>;
  identity: PatientJourneyIdentity;
  input: Scalars['String']['output'];
  lookupKey: PatientJourneyLookupKey;
  lookupRan: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  sources: Array<PatientJourneySourceReport>;
  timeline: Array<PatientJourneyEvent>;
  totalMs: Scalars['Int']['output'];
}

export interface PatientJourneyIdentity {
  __typename?: 'PatientJourneyIdentity';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
}

export interface PatientJourneyIdentityInput {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
}

export interface PatientJourneyIncompleteness {
  __typename?: 'PatientJourneyIncompleteness';
  dropped?: Maybe<Scalars['Int']['output']>;
  truncated?: Maybe<Scalars['Boolean']['output']>;
  unmappable?: Maybe<Scalars['Int']['output']>;
}

export interface PatientJourneyIncompletenessInput {
  dropped?: InputMaybe<Scalars['Int']['input']>;
  truncated?: InputMaybe<Scalars['Boolean']['input']>;
  unmappable?: InputMaybe<Scalars['Int']['input']>;
}

export interface PatientJourneyLookupKey {
  __typename?: 'PatientJourneyLookupKey';
  candidates: Array<PatientJourneyCandidate>;
  email?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  source: PatientJourneyEmailSource;
}

export interface PatientJourneyLookupKeyInput {
  email?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  source: PatientJourneyEmailSource;
}

export enum PatientJourneySource {
  Canvas = 'CANVAS',
  Cognito = 'COGNITO',
  Eligibility = 'ELIGIBILITY',
  Hubspot = 'HUBSPOT',
  Posthog = 'POSTHOG',
  UserTable = 'USER_TABLE'
}

export interface PatientJourneySourceReport {
  __typename?: 'PatientJourneySourceReport';
  incomplete?: Maybe<PatientJourneyIncompleteness>;
  ms?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  source: PatientJourneySource;
  status: PatientJourneySourceStatus;
}

export interface PatientJourneySourceReportInput {
  incomplete?: InputMaybe<PatientJourneyIncompletenessInput>;
  ms?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  source: PatientJourneySource;
  status: PatientJourneySourceStatus;
}

export enum PatientJourneySourceStatus {
  Error = 'ERROR',
  NotFound = 'NOT_FOUND',
  Ok = 'OK',
  Partial = 'PARTIAL',
  Skipped = 'SKIPPED'
}

export interface PatientJourneySummary {
  __typename?: 'PatientJourneySummary';
  findings: Array<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  kind: PatientJourneySummaryKind;
  narrative: Scalars['String']['output'];
  ref: Scalars['String']['output'];
  unknowns: Array<Scalars['String']['output']>;
}

export interface PatientJourneySummaryInput {
  findings: Array<Scalars['String']['input']>;
  headline: Scalars['String']['input'];
  kind: PatientJourneySummaryKind;
  narrative: Scalars['String']['input'];
  ref: Scalars['String']['input'];
  unknowns: Array<Scalars['String']['input']>;
}

export enum PatientJourneySummaryKind {
  AppSession = 'APP_SESSION',
  EligibilityCheck = 'ELIGIBILITY_CHECK'
}

export interface PatientJourneyVerdict {
  __typename?: 'PatientJourneyVerdict';
  category?: Maybe<Scalars['String']['output']>;
  confidence: PatientJourneyConfidence;
  findings: Array<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  narrative: Scalars['String']['output'];
  nextSteps: Array<Scalars['String']['output']>;
  unknowns: Array<Scalars['String']['output']>;
}

export interface PatientJourneyVerdictInput {
  facts: Array<PatientJourneyFactInput>;
  identity: PatientJourneyIdentityInput;
  lookupKey?: InputMaybe<PatientJourneyLookupKeyInput>;
  sources: Array<PatientJourneySourceReportInput>;
  summaries?: InputMaybe<Array<PatientJourneySummaryInput>>;
  timeline: Array<PatientJourneyEventInput>;
}

export interface PatientListConnection {
  __typename?: 'PatientListConnection';
  items: Array<PatientListItem>;
}

export interface PatientListItem {
  __typename?: 'PatientListItem';
  discharged: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
}

export interface PatientPathwayFlagContext {
  __typename?: 'PatientPathwayFlagContext';
  emergencyContactName?: Maybe<Scalars['String']['output']>;
  emergencyContactPhone?: Maybe<Scalars['String']['output']>;
  emergencyContactRelationship?: Maybe<Scalars['String']['output']>;
  flagType: PatientPathwayFlagType;
  patientId: Scalars['ID']['output'];
  patientName?: Maybe<Scalars['String']['output']>;
  patientPhone?: Maybe<Scalars['String']['output']>;
  redFlags?: Maybe<Array<PatientPathwayRedFlag>>;
}

export enum PatientPathwayFlagType {
  Red = 'Red',
  Yellow = 'Yellow'
}

export interface PatientPathwayRedFlag {
  __typename?: 'PatientPathwayRedFlag';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
}

export interface PatientPickerEntry {
  __typename?: 'PatientPickerEntry';
  cognitoSub: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  medicalRecordNumber: Scalars['String']['output'];
}

export interface PatientProfile {
  __typename?: 'PatientProfile';
  dob: Scalars['AWSDate']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  userTimeZone: Scalars['String']['output'];
}

export interface PatientProfileInput {
  dob: Scalars['AWSDate']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userTimeZone: Scalars['String']['input'];
}

export interface PaymentMethodBilled {
  __typename?: 'PaymentMethodBilled';
  card?: Maybe<PaymentMethodCard>;
  orderId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  userPaymentOptionId?: Maybe<Scalars['ID']['output']>;
}

export interface PaymentMethodBilledInput {
  card?: InputMaybe<PaymentMethodCardInput>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  userPaymentOptionId?: InputMaybe<Scalars['ID']['input']>;
}

export interface PaymentMethodCard {
  __typename?: 'PaymentMethodCard';
  bin?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  ccCardNumber?: Maybe<Scalars['String']['output']>;
  ccExpMonth?: Maybe<Scalars['String']['output']>;
  ccExpYear?: Maybe<Scalars['String']['output']>;
  ccNameOnCard?: Maybe<Scalars['String']['output']>;
}

export interface PaymentMethodCardInput {
  bin?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<Scalars['String']['input']>;
  ccCardNumber?: InputMaybe<Scalars['String']['input']>;
  ccExpMonth?: InputMaybe<Scalars['String']['input']>;
  ccExpYear?: InputMaybe<Scalars['String']['input']>;
  ccNameOnCard?: InputMaybe<Scalars['String']['input']>;
}

export interface PaymentSessionInfo {
  __typename?: 'PaymentSessionInfo';
  clientRequestId?: Maybe<Scalars['String']['output']>;
  env?: Maybe<Scalars['String']['output']>;
  errCode?: Maybe<Scalars['String']['output']>;
  internalRequestId?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  merchantSiteId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
}

export interface PermissionCrud {
  __typename?: 'PermissionCRUD';
  create?: Maybe<Scalars['Boolean']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
}

export interface PermissionCrudInput {
  create?: InputMaybe<Scalars['Boolean']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface PhoneNumber {
  __typename?: 'PhoneNumber';
  number?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CandidHealthPhoneType>;
}

export interface PhoneNumberInput {
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CandidHealthPhoneType>;
}

export enum PosNegEnum {
  Negative = 'Negative',
  Positive = 'Positive'
}

export interface PracticeLocation {
  __typename?: 'PracticeLocation';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  macLocality: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
}

export interface PracticeLocationInput {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  macLocality?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
}

export interface ProcessNewInjuryEocInput {
  eocId: Scalars['ID']['input'];
  files: Array<FileInput>;
  goalToAchieve: Scalars['String']['input'];
  limitedActivity: Scalars['String']['input'];
  occurredOn?: InputMaybe<Scalars['AWSDate']['input']>;
  patientId: Scalars['ID']['input'];
  promResponses: Array<Scalars['Int']['input']>;
}

export enum ProcessorStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export enum Prom {
  LowerExtremityFunctionalScale = 'LowerExtremityFunctionalScale',
  NeckDisabilityIndex = 'NeckDisabilityIndex',
  Oswestry = 'OSWESTRY',
  Quickdash = 'Quickdash'
}

export interface PromItem {
  __typename?: 'PromItem';
  appointmentType: AppointmentType;
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  deferredCount: Scalars['Int']['output'];
  endedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  episodeOfCareId: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  lastReminderAt?: Maybe<Scalars['AWSDateTime']['output']>;
  patientId: Scalars['String']['output'];
  promKey: Scalars['String']['output'];
  reminderCount: Scalars['Int']['output'];
  responses: Array<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  status: PromStatus;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
}

export interface PromQrResponse {
  __typename?: 'PromQRResponse';
  id: Scalars['ID']['output'];
  itemScores: Array<Maybe<Scalars['Int']['output']>>;
  promKey: Scalars['String']['output'];
  recordDate?: Maybe<Scalars['AWSDateTime']['output']>;
  sane?: Maybe<Scalars['Int']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
}

export enum PromStatus {
  Completed = 'Completed',
  None = 'None',
  Requested = 'Requested'
}

export enum PromUpdateEvent {
  ModalOpen = 'ModalOpen',
  UserDeferred = 'UserDeferred',
  UserProceeded = 'UserProceeded'
}

export enum Pronouns {
  HeHimHis = 'HeHimHis',
  Other = 'Other',
  SheHerHers = 'SheHerHers',
  TheyThemTheirs = 'TheyThemTheirs'
}

export interface ProviderQualification {
  __typename?: 'ProviderQualification';
  identifier?: Maybe<Array<ProviderQualificationIdentifier>>;
  issuerDisplay?: Maybe<Scalars['String']['output']>;
  licenseState?: Maybe<Scalars['String']['output']>;
  period?: Maybe<ProviderQualificationPeriod>;
  text: Scalars['String']['output'];
}

export interface ProviderQualificationIdentifier {
  __typename?: 'ProviderQualificationIdentifier';
  system?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
}

export interface ProviderQualificationPeriod {
  __typename?: 'ProviderQualificationPeriod';
  end?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
}

export interface ProviderSlotsResponse {
  __typename?: 'ProviderSlotsResponse';
  data: SlotsBundle;
}

export interface ProviderUser {
  __typename?: 'ProviderUser';
  avatar?: Maybe<Scalars['String']['output']>;
  canvasPractitionerId?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['AWSDateTime']['output'];
  dob: Scalars['AWSDate']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender: Gender;
  id: Scalars['ID']['output'];
  introBio?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  licenseState: Array<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  practiceLocations?: Maybe<Array<PracticeLocation>>;
  pronouns: Pronouns;
  ptSince?: Maybe<Scalars['AWSDateTime']['output']>;
  qualifications: Array<ProviderQualification>;
  sex: Sex;
  unavailableHours: Array<UnavailableHour>;
  userGroup: UserGroup;
  userPreferences: ProviderUserPreferences;
  workingHours: Array<Maybe<TimeRange>>;
}

export interface ProviderUserAttribute {
  __typename?: 'ProviderUserAttribute';
  email: Scalars['String']['output'];
  family_name: Scalars['String']['output'];
  given_name: Scalars['String']['output'];
  sub: Scalars['String']['output'];
}

export interface ProviderUserPreferences {
  __typename?: 'ProviderUserPreferences';
  appointmentGap: AppointmentGap;
  notificationPreferences?: Maybe<Array<NotificationPreference>>;
}

export interface ProvidersResponse {
  __typename?: 'ProvidersResponse';
  items: Array<ProviderUser>;
  limit?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
}

export interface Query {
  __typename?: 'Query';
  adminGetUserCognitoAttributes?: Maybe<UserAttribute>;
  adminListCognitoUsers?: Maybe<AdminListCognitoUsersResponse>;
  adminSearchPatientPicker: AdminSearchPatientPickerResponse;
  generateZoomToken?: Maybe<ZoomTokenResponse>;
  getAccommodationForm?: Maybe<AccommodationForm>;
  getAccommodationFormsByPatient?: Maybe<AccommodationFormConnection>;
  getAdminUser?: Maybe<AdminUser>;
  getAppointment?: Maybe<Appointment>;
  getAppointmentCallStatus?: Maybe<AppointmentCallStatus>;
  getAppointments?: Maybe<AppointmentsConnection>;
  getBill?: Maybe<Bill>;
  getCMSVideos: ListCmsVideosResponse;
  getCancelledAppointmentTransactionHistory?: Maybe<Array<CancelledAppointmentTransactions>>;
  getCanvasAppointmentEvents: Array<CanvasAppointmentEvent>;
  getCanvasAppointments?: Maybe<Array<CanvasAppointmentData>>;
  getCareTeam?: Maybe<Array<CareTeamMember>>;
  getChatFilesDownloadUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getChatMessage?: Maybe<ChatMessage>;
  getChatMessagesPinnedByUser?: Maybe<ChatConnection>;
  getClaim?: Maybe<Claim>;
  getClientUser?: Maybe<ClientUser>;
  getClientUsers?: Maybe<ClientsResponse>;
  getClinicalReport?: Maybe<Scalars['String']['output']>;
  getConversation?: Maybe<Conversation>;
  getConversationChatMessages?: Maybe<ChatConnection>;
  getConversations?: Maybe<ConversationsConnection>;
  getCptCodes?: Maybe<CptCodesResponse>;
  getEpisodeOfCare?: Maybe<EpisodeOfCare>;
  getEpisodesOfCare?: Maybe<EpisodeOfCareConnection>;
  getExamForm?: Maybe<ExamForm>;
  getExamFormTags?: Maybe<ExamFormTagsResponse>;
  getExamForms?: Maybe<ExamFormsConnection>;
  getExamFormsAdmin?: Maybe<ExamFormsConnection>;
  getHubspotContact?: Maybe<HubspotContactPrefill>;
  getInAppNotification: InAppNotification;
  getOnboardingSection?: Maybe<OnboardingSectionData>;
  getPatientConditions: Array<PatientCondition>;
  getPatientsForPractitioner: PatientListConnection;
  getProviderUser?: Maybe<ProviderUser>;
  getProviderUsers?: Maybe<ProvidersResponse>;
  getProvidersSlots: Array<ProviderSlotsResponse>;
  getReferralHistory?: Maybe<ReferralHistory>;
  getReferralHistoryByPatientId: Array<ReferralHistory>;
  getSingleCMSVideo?: Maybe<CmsVideo>;
  getSoap?: Maybe<Soap>;
  getUserFileDownloadUrl?: Maybe<Scalars['String']['output']>;
  kemtaiActivities: Array<KemtaiActivity>;
  kemtaiActivityResults: Array<KemtaiActivityResult>;
  kemtaiEmbedSession: KemtaiEmbedSession;
  kemtaiPatient: KemtaiPatient;
  listClaim: ListClaimResponse;
  listInAppNotifications?: Maybe<ListInAppNotificationsResponse>;
  listPromResponses: Array<PromQrResponse>;
  listReferralHistory?: Maybe<ListReferralHistoryResponse>;
  listUserFiles: Array<UserFile>;
  patientJourneyFacts: PatientJourneyFacts;
  patientJourneySummary: PatientJourneySummary;
  patientJourneyVerdict: PatientJourneyVerdict;
  resolveAddress?: Maybe<ResolvedAddress>;
  searchAddresses: Array<AddressSuggestion>;
  searchAllergens: Array<AllergenOption>;
  searchChatMessages?: Maybe<ChatConnection>;
  searchMedications: Array<MedicationOption>;
  validatePhoneNumber: GeneralResponse;
}


export interface QueryAdminGetUserCognitoAttributesArgs {
  sub: Scalars['String']['input'];
}


export interface QueryAdminListCognitoUsersArgs {
  input: AdminListCognitoUsersInput;
}


export interface QueryAdminSearchPatientPickerArgs {
  input: AdminSearchPatientPickerInput;
}


export interface QueryGenerateZoomTokenArgs {
  canvasAppointmentId?: InputMaybe<Scalars['ID']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetAccommodationFormArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetAccommodationFormsByPatientArgs {
  filter?: InputMaybe<AccommodationFormFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
}


export interface QueryGetAdminUserArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetAppointmentArgs {
  appointmentDate: Scalars['String']['input'];
  ptId: Scalars['ID']['input'];
}


export interface QueryGetAppointmentCallStatusArgs {
  canvasAppointmentId: Scalars['ID']['input'];
}


export interface QueryGetAppointmentsArgs {
  filter?: InputMaybe<AppointmentsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
}


export interface QueryGetBillArgs {
  appointmentId: Scalars['String']['input'];
  createdOn: Scalars['AWSDateTime']['input'];
}


export interface QueryGetCmsVideosArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetCancelledAppointmentTransactionHistoryArgs {
  episodeOfCareId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}


export interface QueryGetCanvasAppointmentEventsArgs {
  filter: GetProviderCalendarFilter;
}


export interface QueryGetCanvasAppointmentsArgs {
  patientId: Scalars['ID']['input'];
}


export interface QueryGetCareTeamArgs {
  patientId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryGetChatFilesDownloadUrlArgs {
  input: GetChatFilesDownloadUrlsInput;
}


export interface QueryGetChatMessageArgs {
  conversationId: Scalars['ID']['input'];
  timestamp: Scalars['AWSDateTime']['input'];
}


export interface QueryGetChatMessagesPinnedByUserArgs {
  conversationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  pinnedByPT?: InputMaybe<Scalars['Boolean']['input']>;
  pinnedByPatient?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryGetClaimArgs {
  appointmentId: Scalars['ID']['input'];
}


export interface QueryGetClientUserArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetClientUsersArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetClinicalReportArgs {
  episodeOfCareId: Scalars['String']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
  reportType: Scalars['String']['input'];
}


export interface QueryGetConversationArgs {
  conversationId: Scalars['ID']['input'];
}


export interface QueryGetConversationChatMessagesArgs {
  conversationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetConversationsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  ptId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryGetEpisodeOfCareArgs {
  episodeOfCareId: Scalars['ID']['input'];
}


export interface QueryGetEpisodesOfCareArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
}


export interface QueryGetExamFormArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetExamFormsArgs {
  filter?: InputMaybe<ExamFormFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetExamFormsAdminArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetHubspotContactArgs {
  contactId: Scalars['ID']['input'];
}


export interface QueryGetInAppNotificationArgs {
  timeSent: Scalars['AWSDateTime']['input'];
  userId: Scalars['ID']['input'];
}


export interface QueryGetOnboardingSectionArgs {
  patientId: Scalars['ID']['input'];
  section: OnboardingSection;
}


export interface QueryGetPatientConditionsArgs {
  patientId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryGetPatientsForPractitionerArgs {
  ptId: Scalars['ID']['input'];
}


export interface QueryGetProviderUserArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetProviderUsersArgs {
  filter?: InputMaybe<GetProvidersFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryGetProvidersSlotsArgs {
  filter: GetProvidersSlotsFilter;
}


export interface QueryGetReferralHistoryArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetReferralHistoryByPatientIdArgs {
  patientId: Scalars['ID']['input'];
}


export interface QueryGetSingleCmsVideoArgs {
  id: Scalars['ID']['input'];
}


export interface QueryGetSoapArgs {
  appointmentDate: Scalars['String']['input'];
  ptId: Scalars['ID']['input'];
}


export interface QueryGetUserFileDownloadUrlArgs {
  fileKey: Scalars['String']['input'];
  isAvatarImage?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryKemtaiActivityResultsArgs {
  activityId: Scalars['ID']['input'];
}


export interface QueryKemtaiPatientArgs {
  patientId: Scalars['ID']['input'];
}


export interface QueryListClaimArgs {
  filter?: InputMaybe<ListClaimFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryListInAppNotificationsArgs {
  dateTimeRange: DateTimeRangeInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
}


export interface QueryListPromResponsesArgs {
  patientId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryListReferralHistoryArgs {
  filter?: InputMaybe<ListReferralHistoryFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryListUserFilesArgs {
  folder: Scalars['String']['input'];
}


export interface QueryPatientJourneyFactsArgs {
  input: Scalars['String']['input'];
}


export interface QueryPatientJourneySummaryArgs {
  kind: PatientJourneySummaryKind;
  ref: Scalars['String']['input'];
}


export interface QueryPatientJourneyVerdictArgs {
  input: PatientJourneyVerdictInput;
}


export interface QueryResolveAddressArgs {
  placeId: Scalars['String']['input'];
}


export interface QuerySearchAddressesArgs {
  text: Scalars['String']['input'];
}


export interface QuerySearchAllergensArgs {
  text: Scalars['String']['input'];
}


export interface QuerySearchChatMessagesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  searchTerm: Scalars['String']['input'];
}


export interface QuerySearchMedicationsArgs {
  text: Scalars['String']['input'];
}


export interface QueryValidatePhoneNumberArgs {
  phoneNumber: Scalars['String']['input'];
}

export interface Question {
  __typename?: 'Question';
  promInstructions?: Maybe<Scalars['String']['output']>;
  scaleEndLabel: Scalars['String']['output'];
  scaleLabels?: Maybe<Array<Scalars['String']['output']>>;
  scaleStartLabel: Scalars['String']['output'];
  text: Scalars['String']['output'];
  userAnswer?: Maybe<Scalars['Int']['output']>;
}

export interface QuestionInput {
  __typename?: InputMaybe<Scalars['String']['input']>;
  promInstructions?: InputMaybe<Scalars['String']['input']>;
  scaleEndLabel?: InputMaybe<Scalars['String']['input']>;
  scaleLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scaleStartLabel?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  userAnswer?: InputMaybe<Scalars['Int']['input']>;
}

export interface RedFlagResponse {
  __typename?: 'RedFlagResponse';
  question?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['Boolean']['output']>;
}

export interface RedFlagResponseInput {
  question: Scalars['String']['input'];
  response: Scalars['Boolean']['input'];
}

export interface ReferralDetails {
  __typename?: 'ReferralDetails';
  hasReferralDocument?: Maybe<Scalars['Boolean']['output']>;
  icd10Codes?: Maybe<Array<Scalars['String']['output']>>;
  numberOfVisits?: Maybe<Scalars['Int']['output']>;
  numberOfWeeks?: Maybe<Scalars['Int']['output']>;
  referralDate?: Maybe<Scalars['AWSDate']['output']>;
  referringProviderName?: Maybe<Scalars['String']['output']>;
  referringProviderNote?: Maybe<Scalars['String']['output']>;
  referringProviderNpi?: Maybe<Scalars['String']['output']>;
  referringProviderPhoneNumber?: Maybe<Scalars['AWSPhone']['output']>;
  therapyStartDate?: Maybe<Scalars['AWSDate']['output']>;
}

export interface ReferralDetailsInput {
  hasReferralDocument: Scalars['Boolean']['input'];
  icd10Codes?: InputMaybe<Array<Scalars['String']['input']>>;
  numberOfVisits?: InputMaybe<Scalars['Int']['input']>;
  numberOfWeeks?: InputMaybe<Scalars['Int']['input']>;
  referralDate: Scalars['AWSDate']['input'];
  referringProviderName: Scalars['String']['input'];
  referringProviderNote: Scalars['String']['input'];
  referringProviderNpi: Scalars['String']['input'];
  referringProviderPhoneNumber: Scalars['AWSPhone']['input'];
  therapyStartDate?: InputMaybe<Scalars['AWSDate']['input']>;
}

export interface ReferralHistory {
  __typename?: 'ReferralHistory';
  appointment?: Maybe<Appointment>;
  appointmentSchedulingInfo?: Maybe<AppointmentSchedulingInfo>;
  canvasTriageAppointmentId?: Maybe<Scalars['ID']['output']>;
  conditionDetails?: Maybe<ConditionDetails>;
  createdOn: Scalars['AWSDateTime']['output'];
  episodeOfCareId?: Maybe<Scalars['ID']['output']>;
  healthHistory?: Maybe<HealthHistory>;
  hubspotContactId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insuranceInfo?: Maybe<InsuranceInfo>;
  intakeSource: IntakeSource;
  mskRedFlag?: Maybe<MskRedFlag>;
  onboardingStatus: OnboardingStatus;
  partnershipDetails?: Maybe<PartnershipDetails>;
  patient?: Maybe<ClientUser>;
  patientDetails?: Maybe<PatientDetails>;
  patientEligibility?: Maybe<PatientEligibility>;
  patientId: Scalars['ID']['output'];
  patientProfile?: Maybe<PatientProfile>;
  referralDetails?: Maybe<ReferralDetails>;
  treatmentGoals?: Maybe<TreatmentGoals>;
  triageAppointmentId?: Maybe<Scalars['ID']['output']>;
  updatedOn?: Maybe<Scalars['AWSDateTime']['output']>;
}

export enum ReferralSource {
  EmployerOrWorkplace = 'EmployerOrWorkplace',
  Hss = 'HSS',
  HealthInsurance = 'HealthInsurance',
  NotSure = 'NotSure'
}

export interface ReferringProvider {
  __typename?: 'ReferringProvider';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
}

export interface ReferringProviderInput {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  npi?: InputMaybe<Scalars['String']['input']>;
}

export interface ReorderExamUpdate {
  examFormId: Scalars['ID']['input'];
  familyTag: Scalars['String']['input'];
  order: Scalars['Int']['input'];
}

export interface ReorderFormsInFamilyTagsInput {
  updates?: InputMaybe<Array<ReorderExamUpdate>>;
}

export enum RepsUnit {
  Reps = 'Reps',
  Seconds = 'Seconds'
}

export interface RequestPromInput {
  index: Scalars['Int']['input'];
}

export interface RescheduleAppointmentByCanvasIdInput {
  appointmentDateTime: Scalars['AWSDateTime']['input'];
  appointmentState?: InputMaybe<Scalars['String']['input']>;
  canvasAppointmentId: Scalars['ID']['input'];
  canvasPractitionerId?: InputMaybe<Scalars['ID']['input']>;
}

export interface RescheduleCanvasAppointmentInput {
  appointmentDateTime: Scalars['AWSDateTime']['input'];
  appointmentId: Scalars['ID']['input'];
  appointmentState?: InputMaybe<Scalars['String']['input']>;
  canvasPractitionerId: Scalars['ID']['input'];
}

export interface RescheduleCanvasPhoneAppointmentInput {
  appointmentDateTime: Scalars['AWSDateTime']['input'];
  appointmentState?: InputMaybe<Scalars['String']['input']>;
  canvasAppointmentId: Scalars['ID']['input'];
  canvasPractitionerId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
}

export interface ResolvedAddress {
  __typename?: 'ResolvedAddress';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
}

export interface ScheduleCanvasAppointmentInput {
  appointmentDateTime: Scalars['AWSDateTime']['input'];
  appointmentState?: InputMaybe<Scalars['String']['input']>;
  canvasPractitionerId: Scalars['ID']['input'];
  evaluationNoteId?: InputMaybe<Scalars['ID']['input']>;
  noteType: CanvasNoteTypeCode;
  patientId: Scalars['ID']['input'];
}

export interface ScheduleNewVisitOptionsInput {
  userLocalTimeZone: Scalars['String']['input'];
}

export interface ScheduleNotificationsInput {
  flexibleTimeWindowMode?: InputMaybe<Scalars['String']['input']>;
  input: Scalars['String']['input'];
  scheduleExpression: Scalars['String']['input'];
  scheduleName: Scalars['String']['input'];
}

export interface ScheduleNotificationsResponse {
  __typename?: 'ScheduleNotificationsResponse';
  nextExecutionTime?: Maybe<Scalars['String']['output']>;
  scheduleArn: Scalars['String']['output'];
  scheduleName: Scalars['String']['output'];
}

export interface ScheduledCanvasAppointment {
  __typename?: 'ScheduledCanvasAppointment';
  appointmentDateTime: Scalars['AWSDateTime']['output'];
  canvasAppointmentId: Scalars['String']['output'];
  canvasPractitionerId: Scalars['String']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
}

export interface ScheduledCanvasAppointmentResponse {
  __typename?: 'ScheduledCanvasAppointmentResponse';
  data?: Maybe<ScheduledCanvasAppointment>;
  error?: Maybe<CanvasSchedulerError>;
  success: Scalars['Boolean']['output'];
}

export interface SendNotification {
  __typename?: 'SendNotification';
  hubspotProperties?: Maybe<Scalars['AWSJSON']['output']>;
  input?: Maybe<NotificationInput>;
  message: Scalars['String']['output'];
  parent?: Maybe<SendNotificationParent>;
  ruleKey: NotificationRuleKey;
  targetUserId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
}

export interface SendNotificationInput {
  message: Scalars['String']['input'];
  parent?: InputMaybe<SendNotificationParentInput>;
  ruleKey: NotificationRuleKey;
  targetUserId: Scalars['ID']['input'];
}

export interface SendNotificationParent {
  __typename?: 'SendNotificationParent';
  appointmentDate?: Maybe<Scalars['AWSDateTime']['output']>;
  billId?: Maybe<Scalars['ID']['output']>;
  clientUserId?: Maybe<Scalars['ID']['output']>;
  conversationId?: Maybe<Scalars['ID']['output']>;
  createdOn?: Maybe<Scalars['AWSDateTime']['output']>;
  destinationEmail?: Maybe<Scalars['String']['output']>;
  eocId?: Maybe<Scalars['ID']['output']>;
  ptId?: Maybe<Scalars['ID']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
}

export interface SendNotificationParentInput {
  appointmentDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  billId?: InputMaybe<Scalars['ID']['input']>;
  clientUserId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  createdOn?: InputMaybe<Scalars['AWSDateTime']['input']>;
  destinationEmail?: InputMaybe<Scalars['String']['input']>;
  eocId?: InputMaybe<Scalars['ID']['input']>;
  ptId?: InputMaybe<Scalars['ID']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
}

export interface ServiceLine {
  __typename?: 'ServiceLine';
  chargeAmountCents?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  diagnosisPointers?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  initialReferringProvider?: Maybe<ReferringProvider>;
  placeOfServiceCode?: Maybe<Scalars['String']['output']>;
  procedureCode?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  referringProvider?: Maybe<ReferringProvider>;
  units?: Maybe<Scalars['String']['output']>;
}

export interface ServiceLineInput {
  chargeAmountCents?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  diagnosisPointers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  initialReferringProvider?: InputMaybe<ReferringProviderInput>;
  placeOfServiceCode?: InputMaybe<Scalars['String']['input']>;
  procedureCode?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  referringProvider?: InputMaybe<ReferringProviderInput>;
  units?: InputMaybe<Scalars['String']['input']>;
}

export enum Sex {
  Female = 'Female',
  Male = 'Male'
}

export interface SignSoapTransactionInput {
  appointmentDate: Scalars['AWSDateTime']['input'];
  assessment?: InputMaybe<AssessmentInput>;
  billingCategories?: InputMaybe<Array<BillingCategoryInput>>;
  objectiveExamForms?: InputMaybe<Array<UpdateExamFormInput>>;
  patientCarePlan?: InputMaybe<PatientCarePlanInput>;
  pinnedExams?: InputMaybe<Array<Scalars['String']['input']>>;
  ptId: Scalars['ID']['input'];
  signature?: InputMaybe<SoapSignatureInput>;
  subjectiveExamForms?: InputMaybe<SubjectiveExamFormTypeResultInput>;
}

export interface SingleCategoryPrice {
  __typename?: 'SingleCategoryPrice';
  categoryTotal: Scalars['String']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pricePerUnit: Scalars['String']['output'];
  units: Scalars['Float']['output'];
}

export interface SingleCategoryPriceInput {
  categoryTotal: Scalars['String']['input'];
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pricePerUnit: Scalars['String']['input'];
  units: Scalars['Float']['input'];
}

export interface SlotResource {
  __typename?: 'SlotResource';
  appointmentType?: Maybe<Scalars['String']['output']>;
  end: Scalars['AWSDateTime']['output'];
  start: Scalars['AWSDateTime']['output'];
  status: Scalars['String']['output'];
}

export interface SlotsBundle {
  __typename?: 'SlotsBundle';
  entry?: Maybe<Array<SlotResource>>;
  practitionerId: Scalars['ID']['output'];
  total: Scalars['Int']['output'];
}

export interface Soap {
  __typename?: 'Soap';
  appointmentDate: Scalars['AWSDateTime']['output'];
  areFormsComplete?: Maybe<Scalars['Boolean']['output']>;
  assessment?: Maybe<Assessment>;
  billingCategories?: Maybe<Array<BillingCategory>>;
  objectiveExamForms: Array<ExamForm>;
  objectiveExamOverride?: Maybe<Scalars['String']['output']>;
  patientCarePlan?: Maybe<PatientCarePlan>;
  pinnedExams?: Maybe<Array<Scalars['String']['output']>>;
  practiceLocation?: Maybe<PracticeLocation>;
  ptId: Scalars['ID']['output'];
  signature?: Maybe<SoapSignature>;
  subjectiveExamForms: SubjectiveExamFormTypeResult;
}

export interface SoapInput {
  appointmentDate: Scalars['AWSDateTime']['input'];
  areFormsComplete?: InputMaybe<Scalars['Boolean']['input']>;
  assessment?: InputMaybe<AssessmentInput>;
  billingCategories?: InputMaybe<Array<BillingCategoryInput>>;
  objectiveExamForms?: InputMaybe<Array<UpdateExamFormInput>>;
  patientCarePlan?: InputMaybe<PatientCarePlanInput>;
  pinnedExams?: InputMaybe<Array<Scalars['String']['input']>>;
  practiceLocation?: InputMaybe<PracticeLocationInput>;
  ptId: Scalars['ID']['input'];
  signature?: InputMaybe<SoapSignatureInput>;
  subjectiveExamForms?: InputMaybe<SubjectiveExamFormTypeResultInput>;
}

export interface SoapSignature {
  __typename?: 'SoapSignature';
  createdOn: Scalars['AWSDateTime']['output'];
  ptId: Scalars['ID']['output'];
  ptName: Scalars['String']['output'];
}

export interface SoapSignatureInput {
  createdOn: Scalars['AWSDateTime']['input'];
  ptId: Scalars['ID']['input'];
  ptName: Scalars['String']['input'];
}

export interface StoreOnboardingSectionInput {
  conditionDetails?: InputMaybe<ConditionDetailsSectionInput>;
  consents?: InputMaybe<ConsentsInput>;
  emergencyContact?: InputMaybe<EmergencyContactSectionInput>;
  healthBackground?: InputMaybe<HealthBackgroundSectionInput>;
  homeAddress?: InputMaybe<HomeAddressSectionInput>;
  insurance?: InputMaybe<InsuranceSectionInput>;
  patientId: Scalars['ID']['input'];
  section: OnboardingSection;
  wellBeing?: InputMaybe<WellBeingSectionInput>;
}

export interface StringFilterInput {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
}

export interface SubjectiveExamForm {
  __typename?: 'SubjectiveExamForm';
  examFormId: Scalars['ID']['output'];
  examFormTests: Array<ExamFormTest>;
  examTitle: Scalars['String']['output'];
  order: Scalars['Int']['output'];
}

export interface SubjectiveExamFormInput {
  examFormId: Scalars['ID']['input'];
  examFormTests: Array<InputMaybe<ExamFormTestDataInput>>;
  examTitle: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
}

export interface SubjectiveExamFormTypeResult {
  __typename?: 'SubjectiveExamFormTypeResult';
  additionalNotes?: Maybe<Scalars['String']['output']>;
  exams: Array<SubjectiveExamForm>;
  hypotheticalDiagnoses?: Maybe<Array<Scalars['String']['output']>>;
  verifiedPatientInfo?: Maybe<Scalars['Boolean']['output']>;
  workingRegions: Array<Scalars['String']['output']>;
}

export interface SubjectiveExamFormTypeResultInput {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  exams: Array<SubjectiveExamFormInput>;
  hypotheticalDiagnoses?: InputMaybe<Array<Scalars['String']['input']>>;
  verifiedPatientInfo?: InputMaybe<Scalars['Boolean']['input']>;
  workingRegions?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface Subscriber {
  __typename?: 'Subscriber';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<CandidHealthGender>;
  insuranceCard?: Maybe<InsuranceCard>;
  lastName?: Maybe<Scalars['String']['output']>;
  patientRelationshipToSubscriberCode?: Maybe<Scalars['String']['output']>;
}

export interface SubscriberInput {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<CandidHealthGender>;
  insuranceCard?: InputMaybe<InsuranceCardInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  patientRelationshipToSubscriberCode?: InputMaybe<Scalars['String']['input']>;
}

export interface Subscription {
  __typename?: 'Subscription';
  onCreateChatMessage?: Maybe<ChatMessage>;
  onCreateConversation?: Maybe<Conversation>;
  onCreateInAppNotification?: Maybe<InAppNotification>;
  onUpdateAppointmentCallStatus?: Maybe<AppointmentCallStatus>;
}


export interface SubscriptionOnCreateChatMessageArgs {
  conversationId: Scalars['ID']['input'];
}


export interface SubscriptionOnCreateConversationArgs {
  userId: Scalars['ID']['input'];
}


export interface SubscriptionOnCreateInAppNotificationArgs {
  userId: Scalars['ID']['input'];
}


export interface SubscriptionOnUpdateAppointmentCallStatusArgs {
  canvasAppointmentId: Scalars['ID']['input'];
}

export interface Surgery extends Incident {
  __typename?: 'Surgery';
  affectedBodyRegion: AffectedBodyRegion;
  files: Array<File>;
  occurredOn?: Maybe<Scalars['AWSDate']['output']>;
}

export interface SurgicalHistoryData {
  __typename?: 'SurgicalHistoryData';
  hadSurgery?: Maybe<Scalars['Boolean']['output']>;
  surgeries?: Maybe<Array<OnboardingSurgeryData>>;
}

export interface SurgicalHistorySectionInput {
  hadSurgery: Scalars['Boolean']['input'];
  surgeries?: InputMaybe<Array<OnboardingSurgeryInput>>;
}

export interface TableBooleanFilterInput {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface TableFloatFilterInput {
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
}

export interface TableIdFilterInput {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
}

export interface TableIntFilterInput {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
}

export enum TestKey {
  AccidentOrInjury = 'AccidentOrInjury',
  ActivityYouCareMost = 'ActivityYouCareMost',
  Allergies = 'Allergies',
  BetterOrWorseOverTime = 'BetterOrWorseOverTime',
  CognitiveStatus = 'CognitiveStatus',
  CurrentLevelOfPhysicalActivity = 'CurrentLevelOfPhysicalActivity',
  DexaScanDate = 'DexaScanDate',
  DexaScanResult = 'DexaScanResult',
  FallRiskMedications = 'FallRiskMedications',
  FallRiskPsychological = 'FallRiskPsychological',
  FeelingBadAboutSelf = 'FeelingBadAboutSelf',
  FeelingDownDepressedOrHopeless = 'FeelingDownDepressedOrHopeless',
  FeelingTiredOrLittleEnergy = 'FeelingTiredOrLittleEnergy',
  GoalsYouLikeToAchieve = 'GoalsYouLikeToAchieve',
  HadDexaScan = 'HadDexaScan',
  HadFallenByLosingBalance = 'HadFallenByLosingBalance',
  HistoryOfPresentCondition = 'HistoryOfPresentCondition',
  HowIntense1To10 = 'HowIntense1To10',
  IssuesWithVision = 'IssuesWithVision',
  LittleInterestInDoingThings = 'LittleInterestInDoingThings',
  LowerExtremityFunctionalScale = 'LowerExtremityFunctionalScale',
  MechanismOfInjury = 'MechanismOfInjury',
  Medications = 'Medications',
  MedicationsOtc = 'MedicationsOtc',
  MedicationsSupplements = 'MedicationsSupplements',
  NeckDisabilityIndex = 'NeckDisabilityIndex',
  NoRedFlagSymptoms = 'NoRedFlagSymptoms',
  NumberOfFalls = 'NumberOfFalls',
  Oswestry = 'OSWESTRY',
  PastCancerHistory = 'PastCancerHistory',
  PastSurgicalHistory = 'PastSurgicalHistory',
  PoorAppetiteOrOverEating = 'PoorAppetiteOrOverEating',
  PriorMedicalHistory = 'PriorMedicalHistory',
  PriorTreatment = 'PriorTreatment',
  PsychomotorChanges = 'PsychomotorChanges',
  Quickdash = 'Quickdash',
  RankYourHealth = 'RankYourHealth',
  RankYourMentalHealth = 'RankYourMentalHealth',
  RankYourPhysicalHealth = 'RankYourPhysicalHealth',
  RankYourQualityOfLife = 'RankYourQualityOfLife',
  RecentFalls = 'RecentFalls',
  RedCalfPain = 'RedCalfPain',
  RedCardiacArrestStroke = 'RedCardiacArrestStroke',
  RedCoughingUpBlood = 'RedCoughingUpBlood',
  RedCrushingChestPain = 'RedCrushingChestPain',
  RedFeverChills = 'RedFeverChills',
  RedLossOfBowel = 'RedLossOfBowel',
  RedLossOfConsciousness = 'RedLossOfConsciousness',
  RedSlurredSpeech = 'RedSlurredSpeech',
  RedSuicidal = 'RedSuicidal',
  RedWeakness = 'RedWeakness',
  SleepIssues = 'SleepIssues',
  SubstanceHistory = 'SubstanceHistory',
  SuicidalThoughts = 'SuicidalThoughts',
  TroubleConcentrating = 'TroubleConcentrating',
  UseAssistiveDevice = 'UseAssistiveDevice',
  WhatMakesFeelBetter = 'WhatMakesFeelBetter',
  WhatMakesFeelWorse = 'WhatMakesFeelWorse',
  WhatTypeOfPain = 'WhatTypeOfPain',
  WhenDidOccur = 'WhenDidOccur'
}

export enum TestRowKey {
  Amts4orLessOrSeverelyImpaired = 'AMTS4orLessOrSeverelyImpaired',
  Amts5or6OrModeratelyImpaired = 'AMTS5or6OrModeratelyImpaired',
  Amts7or8OrMildlyImpaired = 'AMTS7or8OrMildlyImpaired',
  Amts9or10Or10orIntact = 'AMTS9or10OR10orIntact',
  AccidentOrInjuryNoBearWeight = 'AccidentOrInjuryNoBearWeight',
  AccidentOrInjuryNotApplicable = 'AccidentOrInjuryNotApplicable',
  AccidentOrInjuryPhysicalDeformity = 'AccidentOrInjuryPhysicalDeformity',
  AccidentOrInjurySeverePain = 'AccidentOrInjurySeverePain',
  ActivityYouCareMostRow = 'ActivityYouCareMostRow',
  AllergiesRow = 'AllergiesRow',
  AppearsMildlyAffectedByOneOrMore = 'AppearsMildlyAffectedByOneOrMore',
  AppearsModeratelyAffectedByOneOrMore = 'AppearsModeratelyAffectedByOneOrMore',
  AppearsSeverelyAffectedByOneOrMore = 'AppearsSeverelyAffectedByOneOrMore',
  BetterOrWorseOverTimeRow = 'BetterOrWorseOverTimeRow',
  CurrentLevelOfPhysicalActivityFairlyActive = 'CurrentLevelOfPhysicalActivityFairlyActive',
  CurrentLevelOfPhysicalActivityInactive = 'CurrentLevelOfPhysicalActivityInactive',
  CurrentLevelOfPhysicalActivityPhysicallyActive = 'CurrentLevelOfPhysicalActivityPhysicallyActive',
  DexaScanDateRow = 'DexaScanDateRow',
  DexaScanResultRow = 'DexaScanResultRow',
  DoesNotAppearToHaveAnyOfThese = 'DoesNotAppearToHaveAnyOfThese',
  GoalsYouLikeToAchieveRow = 'GoalsYouLikeToAchieveRow',
  HpcWhatHappened = 'HPCWhatHappened',
  HpcWhenDidOccur = 'HPCWhenDidOccur',
  HowIntense1To10Row = 'HowIntense1To10Row',
  MoiGradualOnset = 'MOIGradualOnset',
  MoiSuddenOnset = 'MOISuddenOnset',
  MoiTraumaticImpact = 'MOITraumaticImpact',
  MoiUnknown = 'MOIUnknown',
  MedHistoryAsthma = 'MedHistoryAsthma',
  MedHistoryCopd = 'MedHistoryCOPD',
  MedHistoryDvt = 'MedHistoryDVT',
  MedHistoryDepression = 'MedHistoryDepression',
  MedHistoryDiabetes = 'MedHistoryDiabetes',
  MedHistoryHbp = 'MedHistoryHBP',
  MedHistoryHeartDisease = 'MedHistoryHeartDisease',
  MedHistoryOsteoarthritis = 'MedHistoryOsteoarthritis',
  MedHistoryOsteoporosis = 'MedHistoryOsteoporosis',
  MedHistoryRheumatoidArthritis = 'MedHistoryRheumatoidArthritis',
  MedHistorySeizures = 'MedHistorySeizures',
  MedHistoryStroke = 'MedHistoryStroke',
  MedHistoryThyroidDisease = 'MedHistoryThyroidDisease',
  MedicationsOtcRow = 'MedicationsOtcRow',
  MedicationsRow = 'MedicationsRow',
  MedicationsSupplementsRow = 'MedicationsSupplementsRow',
  MoreThanHalfTheDays = 'MoreThanHalfTheDays',
  NearlyEveryDay = 'NearlyEveryDay',
  NoSure = 'NoSure',
  NoTakingAnyMedication = 'NoTakingAnyMedication',
  NoneIn12Months = 'NoneIn12Months',
  NotAtAll = 'NotAtAll',
  NumberOfFallsRow = 'NumberOfFallsRow',
  OneOrMoreBetween3And12Months = 'OneOrMoreBetween3And12Months',
  OneOrMoreInLast3Months = 'OneOrMoreInLast3Months',
  OneOrMoreInLast3MonthsWhileInResident = 'OneOrMoreInLast3MonthsWhileInResident',
  PastCancerHistoryRow = 'PastCancerHistoryRow',
  PastSurgicalHistoryRow = 'PastSurgicalHistoryRow',
  PriorTreatmentAcupuncture = 'PriorTreatmentAcupuncture',
  PriorTreatmentChiropractic = 'PriorTreatmentChiropractic',
  PriorTreatmentMassage = 'PriorTreatmentMassage',
  PriorTreatmentMedicalIntervention = 'PriorTreatmentMedicalIntervention',
  PriorTreatmentMedication = 'PriorTreatmentMedication',
  PriorTreatmentOther = 'PriorTreatmentOther',
  PriorTreatmentPt = 'PriorTreatmentPT',
  PriorTreatmentRest = 'PriorTreatmentRest',
  RedNo = 'RedNo',
  RedNoSymptoms = 'RedNoSymptoms',
  RedYes = 'RedYes',
  SeveralDays = 'SeveralDays',
  SubstanceHistoryAlcohol = 'SubstanceHistoryAlcohol',
  SubstanceHistoryOther = 'SubstanceHistoryOther',
  SubstanceHistoryTobacco = 'SubstanceHistoryTobacco',
  TakingMoreThanTwo = 'TakingMoreThanTwo',
  TakingOne = 'TakingOne',
  TakingTwo = 'TakingTwo',
  WhatMakesFeelBetterRow = 'WhatMakesFeelBetterRow',
  WhatMakesFeelWorseRow = 'WhatMakesFeelWorseRow',
  WhatTypeOfPainAching = 'WhatTypeOfPainAching',
  WhatTypeOfPainDull = 'WhatTypeOfPainDull',
  WhatTypeOfPainNumbness = 'WhatTypeOfPainNumbness',
  WhatTypeOfPainOther = 'WhatTypeOfPainOther',
  WhatTypeOfPainPinsNeedles = 'WhatTypeOfPainPinsNeedles',
  WhatTypeOfPainRadiating = 'WhatTypeOfPainRadiating',
  WhatTypeOfPainSharp = 'WhatTypeOfPainSharp'
}

export interface TimeRange {
  __typename?: 'TimeRange';
  from: Scalars['AWSTime']['output'];
  to: Scalars['AWSTime']['output'];
}

export interface TimeRangeInput {
  from: Scalars['AWSTime']['input'];
  to: Scalars['AWSTime']['input'];
}

export interface TreatmentGoals {
  __typename?: 'TreatmentGoals';
  limitedActivityDetails: Scalars['String']['output'];
  treatmentGoalDetails: Scalars['String']['output'];
}

export interface TreatmentGoalsInput {
  limitedActivityDetails: Scalars['String']['input'];
  treatmentGoalDetails: Scalars['String']['input'];
}

export interface UnavailableHour {
  __typename?: 'UnavailableHour';
  dateTimeRange: DateTimeRange;
  id: Scalars['ID']['output'];
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface UnavailableHourInput {
  dateTimeRange: DateTimeRangeInput;
  id: Scalars['ID']['input'];
  timestamp?: InputMaybe<Scalars['AWSDateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateAccommodationFormInput {
  formData: Scalars['AWSJSON']['input'];
  id: Scalars['ID']['input'];
}

export interface UpdateAppointmentCallStatusInput {
  canvasAppointmentId: Scalars['ID']['input'];
  startedAt: Scalars['AWSDateTime']['input'];
}

export interface UpdateBillInput {
  amountPerCategory?: InputMaybe<Array<SingleCategoryPriceInput>>;
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  claimId?: InputMaybe<Scalars['ID']['input']>;
  coinsurance?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['AWSDateTime']['input']>;
  deductible?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  patientResponsibility?: InputMaybe<Scalars['String']['input']>;
  paymentMethodBilled?: InputMaybe<PaymentMethodBilledInput>;
  totalAmount?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateCanvasAppointmentStatusInput {
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  canvasAppointmentId?: InputMaybe<Scalars['ID']['input']>;
  status: AppointmentStatus;
}

export interface UpdateCanvasEpisodeOfCareInput {
  completeEpisodeOfCare?: InputMaybe<CompleteEpisodeOfCareInput>;
  noteId: Scalars['ID']['input'];
  updateDiagnosis?: InputMaybe<UpdateDiagnosisInput>;
  updateFollowUpCount?: InputMaybe<UpdateFollowUpCountInput>;
}

export interface UpdateCanvasPromResponseInput {
  promKey: Scalars['String']['input'];
  recordedDate: Scalars['AWSDateTime']['input'];
  responses: Array<Scalars['Int']['input']>;
  sane: Scalars['Int']['input'];
}

export interface UpdateChatMessageInput {
  attachmentRefs?: InputMaybe<Array<InputMaybe<FileInput>>>;
  conversationId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  pinnedByPT?: InputMaybe<Scalars['Boolean']['input']>;
  pinnedByPatient?: InputMaybe<Scalars['Boolean']['input']>;
  recipientId?: InputMaybe<Scalars['ID']['input']>;
  senderId?: InputMaybe<Scalars['ID']['input']>;
  timestamp: Scalars['AWSDateTime']['input'];
}

export interface UpdateClaimInput {
  appointmentId: Scalars['ID']['input'];
  benefitsAssignedToProvider?: InputMaybe<Scalars['Boolean']['input']>;
  billableStatus?: InputMaybe<Scalars['String']['input']>;
  billingProvider?: InputMaybe<ClaimProviderInput>;
  claimStatus?: InputMaybe<ClaimStatus>;
  dateOfService?: InputMaybe<Scalars['String']['input']>;
  diagnoses?: InputMaybe<Array<InputMaybe<ClaimDiagnosisInput>>>;
  endDateOfService?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  initialReferringProvider?: InputMaybe<ReferringProviderInput>;
  onsetOfCurrentIllnessOrSymptomDate?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<ClaimPatientInput>;
  patientAuthorizedRelease?: InputMaybe<Scalars['Boolean']['input']>;
  payToAddress?: InputMaybe<AddressInput>;
  placeOfServiceCode?: InputMaybe<Scalars['String']['input']>;
  providerAcceptsAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  referringProvider?: InputMaybe<ReferringProviderInput>;
  renderingProvider?: InputMaybe<ClaimProviderInput>;
  responsibleParty?: InputMaybe<Scalars['String']['input']>;
  serviceLines?: InputMaybe<Array<InputMaybe<ServiceLineInput>>>;
  subscriberPrimary?: InputMaybe<SubscriberInput>;
  subscriberSecondary?: InputMaybe<SubscriberInput>;
  synchronicity?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateClientUserInput {
  acceptedConsentAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  acceptedConsentToCommunicate?: InputMaybe<Scalars['Boolean']['input']>;
  acceptedHIPAAPrivacyNotice?: InputMaybe<Scalars['Boolean']['input']>;
  acceptedPaymentTerms?: InputMaybe<Scalars['Boolean']['input']>;
  acceptedTermsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  dob?: InputMaybe<Scalars['AWSDate']['input']>;
  emergencyContact?: InputMaybe<EmergencyContactInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use sex field instead */
  gender?: InputMaybe<Gender>;
  height?: InputMaybe<HeightInput>;
  homeAddress?: InputMaybe<HomeAddressInput>;
  id: Scalars['ID']['input'];
  insurances?: InputMaybe<Array<InputMaybe<InsuranceItemInput>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  localTimeZone?: InputMaybe<Scalars['String']['input']>;
  medicalRecordNumber?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  patientSummary?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated No longer used */
  pronouns?: InputMaybe<Pronouns>;
  sex?: InputMaybe<Sex>;
  weight?: InputMaybe<Scalars['Int']['input']>;
}

export interface UpdateConversationInput {
  attachmentRefs?: InputMaybe<Array<InputMaybe<FileInput>>>;
  conversationId: Scalars['ID']['input'];
  lastMessage?: InputMaybe<UpdateChatMessageInput>;
  lastMessageTimestamp?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lastSeenByPT?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lastSeenByPatient?: InputMaybe<Scalars['AWSDateTime']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  ptId?: InputMaybe<Scalars['ID']['input']>;
  ptWithAccess?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
}

export interface UpdateDiagnosisInput {
  assessmentNote?: InputMaybe<Scalars['String']['input']>;
  diagnosis: Scalars['String']['input'];
}

export interface UpdateExamFormInput {
  bodyPositionTags?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyRegionTags?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyRegionsApplied?: InputMaybe<Array<Scalars['String']['input']>>;
  bodySegmentTags?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  diagnosisTags?: InputMaybe<Array<Scalars['String']['input']>>;
  examFormId: Scalars['ID']['input'];
  examFormStatus?: InputMaybe<Array<ExamFormStatusInput>>;
  examFormTests?: InputMaybe<Array<ExamFormTestInput>>;
  examTitle?: InputMaybe<Scalars['String']['input']>;
  familyTags?: InputMaybe<Array<Scalars['String']['input']>>;
  familyTagsOrder?: InputMaybe<Array<FamilyTagOrderInput>>;
  formFinished?: InputMaybe<Scalars['Boolean']['input']>;
  functionTags?: InputMaybe<Array<Scalars['String']['input']>>;
  levelTags?: InputMaybe<Array<Scalars['String']['input']>>;
  modifiedAt: Scalars['AWSDateTime']['input'];
  triageSetTags?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface UpdateFollowUpCountInput {
  followUpCount: Scalars['Int']['input'];
}

export interface UpdateInAppNotificationsTransactionInput {
  status: InAppNotificationStatus;
  timestamps: Array<Scalars['AWSDateTime']['input']>;
  userId: Scalars['ID']['input'];
}

export interface UpdatePromItemInput {
  deferred?: InputMaybe<Scalars['Boolean']['input']>;
  endedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  index: Scalars['Int']['input'];
  reminded?: InputMaybe<Scalars['Boolean']['input']>;
  startedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  status?: InputMaybe<PromStatus>;
}

export interface UpdatePromResponseInput {
  appointmentDate: Scalars['AWSDateTime']['input'];
  endedAt: Scalars['AWSDateTime']['input'];
  index: Scalars['Int']['input'];
  ptId: Scalars['String']['input'];
  responses: Array<Scalars['Int']['input']>;
  sane?: InputMaybe<Scalars['Int']['input']>;
  startedAt: Scalars['AWSDateTime']['input'];
}

export interface UpdateProviderUserInput {
  avatar?: InputMaybe<Scalars['String']['input']>;
  canvasPractitionerId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['ID']['input'];
  introBio?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Pronouns>;
  unavailableHours?: InputMaybe<Array<UnavailableHourInput>>;
}

export interface UpdateReferralDocumentDetailsInput {
  referralDetails: ReferralDetailsInput;
  referralId: Scalars['ID']['input'];
}

export interface UpsertExamFormInput {
  bodyPositionTags?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyRegionTags?: InputMaybe<Array<Scalars['String']['input']>>;
  bodyRegionsApplied?: InputMaybe<Array<Scalars['String']['input']>>;
  bodySegmentTags?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  diagnosisTags?: InputMaybe<Array<Scalars['String']['input']>>;
  examFormId?: InputMaybe<Scalars['ID']['input']>;
  examFormStatus?: InputMaybe<Array<ExamFormStatusInput>>;
  examFormTests?: InputMaybe<Array<ExamFormTestInput>>;
  examTitle?: InputMaybe<Scalars['String']['input']>;
  familyTags?: InputMaybe<Array<Scalars['String']['input']>>;
  familyTagsOrder?: InputMaybe<Array<FamilyTagOrderInput>>;
  formFinished?: InputMaybe<Scalars['Boolean']['input']>;
  functionTags?: InputMaybe<Array<Scalars['String']['input']>>;
  levelTags?: InputMaybe<Array<Scalars['String']['input']>>;
  modifiedAt: Scalars['AWSDateTime']['input'];
  triageSetTags?: InputMaybe<Array<Scalars['String']['input']>>;
}

export type UserAttribute = AdminUserAttribute | ClientUserAttribute | ProviderUserAttribute;

export interface UserFile {
  __typename?: 'UserFile';
  fileKey: Scalars['String']['output'];
  lastModified: Scalars['AWSDateTime']['output'];
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
}

export enum UserGroup {
  AdminGroup = 'AdminGroup',
  ClientGroup = 'ClientGroup',
  ExternalPartnerGroup = 'ExternalPartnerGroup',
  ProviderGroup = 'ProviderGroup'
}

export enum VerificationErrorType {
  CandidErrors = 'CANDID_ERRORS',
  CopayCalculationFailed = 'COPAY_CALCULATION_FAILED',
  EligibilityCheckFailed = 'ELIGIBILITY_CHECK_FAILED',
  GroupNumberNotFound = 'GROUP_NUMBER_NOT_FOUND',
  InvalidInput = 'INVALID_INPUT',
  PlanNotActive = 'PLAN_NOT_ACTIVE',
  ServerError = 'SERVER_ERROR',
  UnsupportedInsurance = 'UNSUPPORTED_INSURANCE'
}

export enum VerifiedFor {
  AmazonInsurancePlan = 'AMAZON_INSURANCE_PLAN',
  AmazonSelfPay = 'AMAZON_SELF_PAY',
  InsurancePlan = 'INSURANCE_PLAN'
}

export interface VerifyInsuranceData {
  __typename?: 'VerifyInsuranceData';
  copay?: Maybe<Scalars['Float']['output']>;
  deductible?: Maybe<Deductible>;
  initialCost?: Maybe<Scalars['Float']['output']>;
  reAssessmentCost?: Maybe<Scalars['Float']['output']>;
  verifiedFor: VerifiedFor;
}

export interface VerifyInsuranceInput {
  dateOfBirth: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  memberId?: InputMaybe<Scalars['String']['input']>;
  payerId: Scalars['String']['input'];
  referredEmployerOrWorkplace?: InputMaybe<Scalars['String']['input']>;
}

export interface VerifyInsuranceResponse {
  __typename?: 'VerifyInsuranceResponse';
  data?: Maybe<VerifyInsuranceData>;
  error?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<VerificationErrorType>;
  success: Scalars['Boolean']['output'];
}

export interface WellBeingData {
  __typename?: 'WellBeingData';
  phqAppetite?: Maybe<Scalars['Int']['output']>;
  phqBadAboutSelf?: Maybe<Scalars['Int']['output']>;
  phqConcentrating?: Maybe<Scalars['Int']['output']>;
  phqDownDepressed?: Maybe<Scalars['Int']['output']>;
  phqEnergy?: Maybe<Scalars['Int']['output']>;
  phqInterest?: Maybe<Scalars['Int']['output']>;
  phqPsychomotor?: Maybe<Scalars['Int']['output']>;
  phqSleep?: Maybe<Scalars['Int']['output']>;
  phqSuicidalThoughts?: Maybe<Scalars['Int']['output']>;
}

export interface WellBeingSectionInput {
  phqAppetite?: InputMaybe<Scalars['Int']['input']>;
  phqBadAboutSelf?: InputMaybe<Scalars['Int']['input']>;
  phqConcentrating?: InputMaybe<Scalars['Int']['input']>;
  phqDownDepressed: Scalars['Int']['input'];
  phqEnergy?: InputMaybe<Scalars['Int']['input']>;
  phqInterest: Scalars['Int']['input'];
  phqPsychomotor?: InputMaybe<Scalars['Int']['input']>;
  phqSleep?: InputMaybe<Scalars['Int']['input']>;
  phqSuicidalThoughts?: InputMaybe<Scalars['Int']['input']>;
}

export interface ZoomTokenResponse {
  __typename?: 'ZoomTokenResponse';
  token: Scalars['String']['output'];
  topic?: Maybe<Scalars['String']['output']>;
}
